/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * Nestjs FTW
 * The Client Portal API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type GetOneBaseEmployeeControllerEmployeeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseEmployeeControllerEmployeeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseClientControllerClientParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseClientControllerClientParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseOtpControllerOtpParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseOtpControllerOtpParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseDepartmentControllerDepartmentParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseDepartmentControllerDepartmentParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseContractTypeControllerContractTypeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseContractTypeControllerContractTypeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseDocumentTypeControllerDocumentTypeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseDocumentTypeControllerDocumentTypeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseMassContractItemControllerMassContractItemParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseMassContractItemControllerMassContractItemParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseMassContractControllerMassContractParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseMassContractControllerMassContractParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseEContractTrackingControllerEContractTrackingParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseEContractTrackingControllerEContractTrackingParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseEContractSigneeControllerEContractSigneeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseEContractSigneeControllerEContractSigneeParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseEContractControllerEContractParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseEContractControllerEContractParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseUserSignatureControllerUserSignatureParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseUserSignatureControllerUserSignatureParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseUserControllerUserParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseUserControllerUserParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type OtpStatus = typeof OtpStatus[keyof typeof OtpStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OtpStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export interface Otp {
  readonly createdAt: string;
  createdTime?: string;
  entityId?: string;
  readonly id?: string;
  status: OtpStatus;
  timeExpiredAmount?: number;
  token?: string;
  userId?: string;
}

export interface GetManyOtpResponseDto {
  count: number;
  data: Otp[];
  page: number;
  pageCount: number;
  total: number;
}

export interface VerifyOtpDto {
  eContractId: string;
  employeeId: string;
  otp: string;
}

export interface RequestEmailOtpDto {
  eContractId: string;
  employeeId: string;
}

export interface SendEmailRemindDto {
  eContractId: string;
  employeeId?: string;
  userId?: string;
}

export type DocumentTypeStatus = typeof DocumentTypeStatus[keyof typeof DocumentTypeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentTypeStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export interface DocumentType {
  code?: string;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  description?: string | null;
  readonly id?: string;
  name: string;
  nameUnAccent?: string;
  sortOrder?: number;
  status: DocumentTypeStatus;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface GetManyDocumentTypeResponseDto {
  count: number;
  data: DocumentType[];
  page: number;
  pageCount: number;
  total: number;
}

export type MassContractItemTrackingAction = typeof MassContractItemTrackingAction[keyof typeof MassContractItemTrackingAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractItemTrackingAction = {
  SaveDraft: 'SaveDraft',
  SendRequestToSignee: 'SendRequestToSignee',
  SignOff: 'SignOff',
  Cancel: 'Cancel',
  SendReminder: 'SendReminder',
} as const;

export interface MassContractItemTracking {
  action: MassContractItemTrackingAction;
  actionUser?: string | null;
  readonly deletedAt?: string;
  description?: string | null;
  deviceCode?: string | null;
  employeeId?: string | null;
  readonly id?: string;
  ipAddress?: string | null;
  massContractItemId?: string;
  userId?: string;
}

export interface GetManyMassContractItemTrackingResponseDto {
  count: number;
  data: MassContractItemTracking[];
  page: number;
  pageCount: number;
  total: number;
}

export type MassContractItemSigneeStatus = typeof MassContractItemSigneeStatus[keyof typeof MassContractItemSigneeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractItemSigneeStatus = {
  Waiting: 'Waiting',
  Draft: 'Draft',
  Signed: 'Signed',
} as const;

export type MassContractItemSigneeSignatureType = typeof MassContractItemSigneeSignatureType[keyof typeof MassContractItemSigneeSignatureType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractItemSigneeSignatureType = {
  Electronic: 'Electronic',
  Digital: 'Digital',
  Image: 'Image',
} as const;

export type MassContractItemSigneeBelongTo = typeof MassContractItemSigneeBelongTo[keyof typeof MassContractItemSigneeBelongTo];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractItemSigneeBelongTo = {
  MyCorporation: 'MyCorporation',
  Partner: 'Partner',
} as const;

export interface MassContractItemSignee {
  autoSendReminder: boolean;
  autoSign: boolean;
  belongTo: MassContractItemSigneeBelongTo;
  email: string;
  employeeId?: string | null;
  readonly id?: string;
  massContractItemId?: string;
  pageNumber: number;
  phoneNumber: string;
  positionX: number;
  positionY: number;
  rectangeHeight: number;
  rectangeWidth: number;
  reminderMessage: string;
  sendReminderAfter: number;
  signatureFileUrl: string;
  signatureId?: string;
  signatureType: MassContractItemSigneeSignatureType;
  signOrder: number;
  status: MassContractItemSigneeStatus;
  userId?: string;
}

export interface GetManyMassContractItemSigneeResponseDto {
  count: number;
  data: MassContractItemSignee[];
  page: number;
  pageCount: number;
  total: number;
}

export interface CreateMassEContractDto {
  clientCode?: string | null;
  clientId?: string | null;
  readonly code?: string | null;
  completedCount: number;
  contractCount: number;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  departmentId?: string | null;
  eContractSigneeCreateInputs: EContractSigneeCreateInput[];
  emailContent: string;
  readonly expiredAt?: string;
  lineInCharge?: string;
  lineInChargeId?: string;
  personInCharge?: string;
  personInChargeId?: string;
  typeId?: string;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface SendToSignMassDto {
  readonly eContractSigneeId?: string;
  massContractId: string;
}

export interface UpdateMassEContractWithSigneesDto {
  clientCode?: string | null;
  clientId?: string | null;
  readonly code?: string | null;
  completedCount: number;
  contractCount: number;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  departmentId?: string | null;
  eContractSigneeCreateInputs: EContractSigneeCreateInput[];
  emailContent: string;
  readonly expiredAt?: string;
  id?: string | null;
  lineInCharge?: string;
  lineInChargeId?: string;
  personInCharge?: string;
  personInChargeId?: string;
  typeId?: string;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface FilesUploadDTO {
  files: Blob[];
}

export type UpdateEContractStatus = typeof UpdateEContractStatus[keyof typeof UpdateEContractStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEContractStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export type UpdateEContractIndustry = typeof UpdateEContractIndustry[keyof typeof UpdateEContractIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEContractIndustry = {
  Individual: 'Individual',
  Company: 'Company',
} as const;

export interface UpdateEContract {
  attachmentFiles?: string;
  clientCode?: string;
  clientId?: string;
  readonly code?: string;
  contractFile?: string;
  readonly department?: Department;
  readonly departmentId?: string;
  emailContent?: string;
  readonly expiredAt?: string;
  industry?: UpdateEContractIndustry;
  isReviewed?: boolean;
  lineInCharge?: string;
  readonly massContract?: MassContract;
  readonly massContractId?: string;
  personInCharge?: string;
  previewContractFile?: string;
  readonly publishedAt?: string;
  signCount?: number;
  signProcessed?: number;
  status?: UpdateEContractStatus;
  readonly type?: ContractType;
  typeId?: string;
}

export type EContractUpdateInputStatus = typeof EContractUpdateInputStatus[keyof typeof EContractUpdateInputStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractUpdateInputStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export type EContractUpdateInputIndustry = typeof EContractUpdateInputIndustry[keyof typeof EContractUpdateInputIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractUpdateInputIndustry = {
  Individual: 'Individual',
  Company: 'Company',
} as const;

export interface EContractUpdateInput {
  attachmentFiles?: string;
  clientCode: string;
  clientId?: string;
  code?: string;
  /** trường contractFile cần được stringyfy, lưu dưới dạng array */
  contractFile?: string;
  departmentId?: string;
  emailContent?: string;
  expiredAt?: string;
  id: string;
  industry: EContractUpdateInputIndustry;
  lineInCharge?: string;
  lineInChargeId?: string;
  readonly massContractId?: string;
  personInCharge?: string;
  personInChargeId?: string;
  readonly previewContractFile?: string;
  signCount?: number;
  signProcessed?: number;
  status?: EContractUpdateInputStatus;
  typeId?: string;
}

export interface UpdateEContractWithSigneesDto {
  eContract?: EContractUpdateInput;
  eContractSignees?: EContractSigneeCreateInput[];
}

export type EContractSigneeCreateInputStatus = typeof EContractSigneeCreateInputStatus[keyof typeof EContractSigneeCreateInputStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeCreateInputStatus = {
  Waiting: 'Waiting',
  Draft: 'Draft',
  Signed: 'Signed',
} as const;

export type EContractSigneeCreateInputSignatureType = typeof EContractSigneeCreateInputSignatureType[keyof typeof EContractSigneeCreateInputSignatureType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeCreateInputSignatureType = {
  Electronic: 'Electronic',
  Digital: 'Digital',
  Image: 'Image',
} as const;

export type EContractSigneeCreateInputBelongTo = typeof EContractSigneeCreateInputBelongTo[keyof typeof EContractSigneeCreateInputBelongTo];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeCreateInputBelongTo = {
  MyCorporation: 'MyCorporation',
  Partner: 'Partner',
} as const;

export interface EContractSigneeCreateInput {
  autoSendReminder?: boolean;
  autoSign: boolean;
  belongTo: EContractSigneeCreateInputBelongTo;
  bottompos?: number;
  clientCode?: string;
  contract: EContract;
  readonly eContractId?: string;
  email: string;
  employeeCode?: string;
  employeeId?: string;
  employeeName?: string;
  pageNumber?: number;
  phoneNumber?: string;
  positionX?: number;
  positionY?: number;
  rectangeHeight?: number;
  rectangeWidth?: number;
  reminderMessage?: string;
  sendReminderAfter?: number;
  sentMailAt?: boolean;
  signatureFileUrl?: string;
  signatureId?: string;
  signatureName?: string;
  signatureType?: EContractSigneeCreateInputSignatureType;
  signOrder: number;
  status?: EContractSigneeCreateInputStatus;
  uniqueKeyword?: string;
  userId?: string;
  userName?: string;
}

export type EContractCreateInputStatus = typeof EContractCreateInputStatus[keyof typeof EContractCreateInputStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractCreateInputStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export type EContractCreateInputIndustry = typeof EContractCreateInputIndustry[keyof typeof EContractCreateInputIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractCreateInputIndustry = {
  Individual: 'Individual',
  Company: 'Company',
} as const;

export interface EContractCreateInput {
  attachmentFiles: string;
  clientCode: string;
  clientId: string;
  code?: string;
  /** trường contractFile cần được stringyfy, lưu dưới dạng array */
  contractFile?: string;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  departmentId: string;
  emailContent: string;
  expiredAt?: string;
  industry: EContractCreateInputIndustry;
  lineInCharge?: string;
  lineInChargeId?: string;
  readonly massContractId?: string;
  originalContractFile?: string;
  personInCharge?: string;
  personInChargeId?: string;
  readonly previewContractFile?: string;
  signCount: number;
  signProcessed: number;
  status: EContractCreateInputStatus;
  typeId?: string;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface CreateEContractDto {
  eContract?: EContractCreateInput;
  eContractSignees?: EContractSigneeCreateInput[];
}

export type EContractStatus = typeof EContractStatus[keyof typeof EContractStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export type EContractIndustry = typeof EContractIndustry[keyof typeof EContractIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractIndustry = {
  Individual: 'Individual',
  Company: 'Company',
} as const;

export interface EContract {
  attachmentFiles: string;
  client: Client;
  clientCode: string;
  clientId: string;
  readonly code: string;
  contractFile: string;
  readonly createdAt: string;
  createdBy: User;
  readonly createdById: string;
  readonly deletedAt: string;
  department: Department;
  departmentId: string;
  eContractSignees: EContractSignee[];
  eContractTrackings: EContractTracking[];
  emailContent: string;
  readonly expiredAt: string;
  readonly id?: string;
  industry: EContractIndustry;
  isReviewed: boolean;
  lineInCharge: string;
  lineInChargeId?: string;
  lineInChargeUser?: User;
  massContract: MassContract;
  readonly massContractId: string;
  originalContractFile: string;
  personInCharge: string;
  personInChargeId?: string;
  personInChargeUser?: User;
  previewContractFile: string;
  readonly publishedAt: string;
  signCount: number;
  signProcessed: number;
  status: EContractStatus;
  type: ContractType;
  typeId: string;
  readonly updatedAt: string;
  updatedBy: User;
  readonly updatedById?: string;
}

export type EContractTrackingAction = typeof EContractTrackingAction[keyof typeof EContractTrackingAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractTrackingAction = {
  SaveDraft: 'SaveDraft',
  SendRequestToSignee: 'SendRequestToSignee',
  SignOff: 'SignOff',
  Cancel: 'Cancel',
  SendReminder: 'SendReminder',
} as const;

export interface EContractTracking {
  action?: EContractTrackingAction;
  actionUser?: string | null;
  readonly createdAt?: string;
  description?: string | null;
  deviceCode?: string | null;
  eContractId?: string;
  employeeId?: string | null;
  readonly id?: string;
  ipAddress?: string | null;
  userId?: string;
}

export interface GetManyEContractTrackingResponseDto {
  count: number;
  data: EContractTracking[];
  page: number;
  pageCount: number;
  total: number;
}

export type EContractSigneeStatus = typeof EContractSigneeStatus[keyof typeof EContractSigneeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeStatus = {
  Waiting: 'Waiting',
  Draft: 'Draft',
  Signed: 'Signed',
} as const;

export type EContractSigneeSignatureType = typeof EContractSigneeSignatureType[keyof typeof EContractSigneeSignatureType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeSignatureType = {
  Electronic: 'Electronic',
  Digital: 'Digital',
  Image: 'Image',
} as const;

export type EContractSigneeBelongTo = typeof EContractSigneeBelongTo[keyof typeof EContractSigneeBelongTo];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EContractSigneeBelongTo = {
  MyCorporation: 'MyCorporation',
  Partner: 'Partner',
} as const;

export interface GetManyEContractSigneeResponseDto {
  count: number;
  data: EContractSignee[];
  page: number;
  pageCount: number;
  total: number;
}

export type ClientStatus = typeof ClientStatus[keyof typeof ClientStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export interface Client {
  address: string;
  code?: string;
  readonly createdAt: string;
  createdBy: User;
  readonly createdById: string;
  readonly deletedAt: string;
  eContracts?: EContract[];
  employees?: Employee[];
  readonly id?: string;
  massContracts?: MassContract[];
  name: string;
  nameUnAccent: string;
  personIncharge: string;
  personInchargeId: string;
  personInchargeUser: User;
  status: ClientStatus;
  taxCode: string;
  readonly updatedAt: string;
  updatedBy: User;
  readonly updatedById?: string;
}

export type MassContractStatus = typeof MassContractStatus[keyof typeof MassContractStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export type MassContractIndustry = typeof MassContractIndustry[keyof typeof MassContractIndustry];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractIndustry = {
  Individual: 'Individual',
  Company: 'Company',
} as const;

export interface MassContract {
  client?: Client;
  clientCode?: string | null;
  clientId?: string | null;
  readonly code?: string | null;
  completedCount?: number;
  contractCount?: number;
  readonly createdAt?: string;
  readonly createdBy?: User;
  readonly createdById?: string;
  readonly deletedAt?: string;
  readonly department?: Department;
  departmentId?: string | null;
  readonly eContracts?: readonly EContract[];
  emailContent?: string;
  readonly expiredAt?: string;
  readonly id?: string;
  industry?: MassContractIndustry;
  isReviewed?: boolean;
  lineInCharge?: string;
  lineInChargeId?: string;
  readonly lineInChargeUser?: User;
  personInCharge?: string;
  personInChargeId?: string;
  readonly personInChargeUser?: User;
  status?: MassContractStatus;
  readonly type?: ContractType;
  typeId?: string;
  readonly updatedAt?: string;
  readonly updatedBy?: User;
  readonly updatedById?: string;
}

export type ContractTypeStatus = typeof ContractTypeStatus[keyof typeof ContractTypeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractTypeStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export interface ContractType {
  code?: string;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  description?: string | null;
  eContracts?: EContract[];
  readonly id?: string;
  massContractItems?: MassContractItem[];
  massContracts?: MassContract[];
  name: string;
  nameUnAccent?: string;
  sortOrder: number;
  status: ContractTypeStatus;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export type MassContractItemStatus = typeof MassContractItemStatus[keyof typeof MassContractItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MassContractItemStatus = {
  Draft: 'Draft',
  Publish: 'Publish',
  Inprocess: 'Inprocess',
  Completed: 'Completed',
  Canceled: 'Canceled',
} as const;

export interface MassContractItem {
  code?: string | null;
  contractFile?: string | null;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  readonly id?: string;
  massContractId?: string;
  signCount?: number | null;
  signProcessed?: number | null;
  status: MassContractItemStatus;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface GetManyMassContractItemResponseDto {
  count: number;
  data: MassContractItem[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyContractTypeResponseDto {
  count: number;
  data: ContractType[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyMassContractResponseDto {
  count: number;
  data: MassContract[];
  page: number;
  pageCount: number;
  total: number;
}

export type EmployeeStatus = typeof EmployeeStatus[keyof typeof EmployeeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployeeStatus = {
  Working: 'Working',
  Maternity: 'Maternity',
  Terminated: 'Terminated',
} as const;

export type DepartmentStatus = typeof DepartmentStatus[keyof typeof DepartmentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepartmentStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export interface Department {
  code?: string;
  readonly createdAt?: string;
  readonly createdById?: string;
  readonly deletedAt?: string;
  description?: string | null;
  readonly id?: string;
  name: string;
  nameUnAccent?: string;
  sortOrder?: number;
  status: DepartmentStatus;
  readonly updatedAt?: string;
  readonly updatedById?: string;
}

export interface Employee {
  client: Client;
  clientCode: string;
  clientId: string;
  clientName: string;
  code?: string;
  readonly createdAt: string;
  createdBy: User;
  readonly createdById: string;
  readonly deletedAt: string;
  department: Department;
  departmentId: string;
  departmentName: string;
  email: string;
  fullName: string;
  fullNameUnAccent: string;
  readonly id?: string;
  identifyNumber: string;
  phoneNumber: string;
  position: string;
  status: EmployeeStatus;
  readonly updatedAt: string;
  updatedBy: User;
  readonly updatedById?: string;
}

export interface EContractSignee {
  autoSendReminder?: boolean;
  autoSign: boolean;
  backIdData?: string;
  backIdImage?: string;
  belongTo: EContractSigneeBelongTo;
  bottompos?: number;
  clientCode?: string;
  readonly createdAt?: string;
  eContract?: EContract;
  readonly eContractId?: string;
  email: string;
  employee?: Employee;
  employeeCode?: string;
  employeeId?: string;
  employeeName?: string;
  eSignPassword?: string;
  eSignSessionId?: string;
  eSignUserName?: string;
  frontIdData?: string;
  frontIdImage?: string;
  readonly id?: string;
  pageNumber?: number;
  phoneNumber: string;
  positionX?: number;
  positionY?: number;
  rectangeHeight?: number;
  rectangeWidth?: number;
  reminderMessage: string;
  sendReminderAfter: number;
  sentMailAt?: string;
  signature?: UserSignature;
  signatureFileUrl?: string;
  signatureId?: string;
  signatureName?: string;
  signatureType?: EContractSigneeSignatureType;
  readonly signedAt: string;
  signOrder: number;
  status?: EContractSigneeStatus;
  uniqueKeyword?: string;
  user?: User;
  userId?: string;
  userName?: string;
  verifyIdData?: string;
  verifyIdImage?: string;
}

export interface GetManyDepartmentResponseDto {
  count: number;
  data: Department[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyEmployeeResponseDto {
  count: number;
  data: Employee[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyClientResponseDto {
  count: number;
  data: Client[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyEContractResponseDto {
  count: number;
  data: EContract[];
  page: number;
  pageCount: number;
  total: number;
}

export interface SendToSignDto {
  eContractId: string;
  readonly eContractSigneeId?: string;
}

export interface SignEContractDto {
  cccdBase64?: string;
  eContractId: string;
  employeeId?: string;
  esignCardNo?: string;
  esignFullName?: string;
  esignPassword?: string;
  esignUserName?: string;
  imgBase64?: string;
  isPreview?: boolean;
  /** Mã sw xác định file ký được truyền từ hệ thống nào lên (HRO | CIS |  HR) */
  readonly source?: string;
  userId?: string;
  userSignatureId?: string;
}

export interface VerifySmsDto {
  email?: string;
  employeeId?: string;
  phoneNumber?: string;
  smsOtp?: string;
}

export interface VerifyIdDto {
  base64img?: string;
  eContractId?: string;
  employeeId?: string;
  isFront?: boolean;
  sessionId?: string;
  userId?: string;
}

export interface CloneEContractDto {
  eContractId: string;
}

export type UserSignatureType = typeof UserSignatureType[keyof typeof UserSignatureType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSignatureType = {
  Electronic: 'Electronic',
  Digital: 'Digital',
  Image: 'Image',
} as const;

export interface UserSignature {
  cardNo: string;
  createdAt?: string;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  employeeId?: string;
  eSignPassword?: string;
  eSignSessionId?: string;
  eSignUserName?: string;
  readonly id?: string;
  name: string;
  nameUnAccent?: string | null;
  signatureFile?: string | null;
  type: UserSignatureType;
  updatedAt?: string;
  updatedById?: string;
  userId?: string;
}

export interface GetManyUserSignatureResponseDto {
  count: number;
  data: UserSignature[];
  page: number;
  pageCount: number;
  total: number;
}

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserStatus = {
  Active: 'Active',
  InActive: 'InActive',
  Locked: 'Locked',
} as const;

export type UserGender = typeof UserGender[keyof typeof UserGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserGender = {
  Male: 'Male',
  Female: 'Female',
} as const;

export interface User {
  avatarUrl?: string;
  code: string;
  createdAt?: string;
  createdById?: string;
  deletedAt?: string;
  email: string;
  fullName?: string;
  fullNameUnAccent?: string;
  gender: UserGender;
  readonly id?: string;
  isSuperAdmin?: boolean;
  jobTitle?: string;
  originalId?: string;
  parent?: User;
  parentId?: string;
  phoneNumber?: string;
  status?: UserStatus;
  updatedAt?: string;
  updatedById?: string;
}

export interface GetManyUserResponseDto {
  count: number;
  data: User[];
  page: number;
  pageCount: number;
  total: number;
}

export interface FileUploadDTO {
  file: Blob;
}

export interface LoginTSMInput {
  token: string;
}

export interface LoginInput {
  email: string;
}





export const appControllerLogin = (
    loginInput: LoginInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/login`,
      loginInput,options
    );
  }



export const getAppControllerLoginMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,{data: LoginInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,{data: LoginInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appControllerLogin>>, {data: LoginInput}> = (props) => {
          const {data} = props ?? {};

          return  appControllerLogin(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type AppControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof appControllerLogin>>>
    export type AppControllerLoginMutationBody = LoginInput
    export type AppControllerLoginMutationError = AxiosError<unknown>

    export const useAppControllerLogin = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLogin>>, TError,{data: LoginInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getAppControllerLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const appControllerLoginTSM = (
    loginTSMInput: LoginTSMInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/login-tsm`,
      loginTSMInput,options
    );
  }



export const getAppControllerLoginTSMMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appControllerLoginTSM>>, {data: LoginTSMInput}> = (props) => {
          const {data} = props ?? {};

          return  appControllerLoginTSM(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type AppControllerLoginTSMMutationResult = NonNullable<Awaited<ReturnType<typeof appControllerLoginTSM>>>
    export type AppControllerLoginTSMMutationBody = LoginTSMInput
    export type AppControllerLoginTSMMutationError = AxiosError<unknown>

    export const useAppControllerLoginTSM = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getAppControllerLoginTSMMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const appControllerGetUserPermissions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/user-permissions`,options
    );
  }


export const getAppControllerGetUserPermissionsQueryKey = () => {
    return [`/user-permissions`] as const;
    }

    
export const getAppControllerGetUserPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetUserPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetUserPermissions>>> = ({ signal }) => appControllerGetUserPermissions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerGetUserPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetUserPermissions>>>
export type AppControllerGetUserPermissionsQueryError = AxiosError<unknown>

export const useAppControllerGetUserPermissions = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppControllerGetUserPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Import a file
 */
export const userControllerImportUsers = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/user/import-user`,
      formData,options
    );
  }



export const getUserControllerImportUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerImportUsers>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerImportUsers>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerImportUsers>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  userControllerImportUsers(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UserControllerImportUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerImportUsers>>>
    export type UserControllerImportUsersMutationBody = FileUploadDTO
    export type UserControllerImportUsersMutationError = AxiosError<unknown>

    export const useUserControllerImportUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerImportUsers>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUserControllerImportUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single User
 */
export const createOneBaseUserControllerUser = (
    user: NonReadonly<User>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    return axios.post(
      `/user`,
      user,options
    );
  }



export const getCreateOneBaseUserControllerUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserControllerUser>>, TError,{data: NonReadonly<User>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserControllerUser>>, TError,{data: NonReadonly<User>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseUserControllerUser>>, {data: NonReadonly<User>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseUserControllerUser(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseUserControllerUserMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseUserControllerUser>>>
    export type CreateOneBaseUserControllerUserMutationBody = NonReadonly<User>
    export type CreateOneBaseUserControllerUserMutationError = AxiosError<unknown>

    /**
 * @summary Create a single User
 */
export const useCreateOneBaseUserControllerUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserControllerUser>>, TError,{data: NonReadonly<User>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseUserControllerUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple Users
 */
export const getManyBaseUserControllerUser = (
    params?: GetManyBaseUserControllerUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyUserResponseDto>> => {
    
    return axios.get(
      `/user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseUserControllerUserQueryKey = (params?: GetManyBaseUserControllerUserParams,) => {
    return [`/user`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseUserControllerUserQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUser>>, TError = AxiosError<unknown>>(params?: GetManyBaseUserControllerUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseUserControllerUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseUserControllerUser>>> = ({ signal }) => getManyBaseUserControllerUser(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseUserControllerUserQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseUserControllerUser>>>
export type GetManyBaseUserControllerUserQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple Users
 */
export const useGetManyBaseUserControllerUser = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUser>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseUserControllerUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseUserControllerUserQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single User
 */
export const updateOneBaseUserControllerUser = (
    id: string,
    user: NonReadonly<User>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    return axios.patch(
      `/user/${id}`,
      user,options
    );
  }



export const getUpdateOneBaseUserControllerUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserControllerUser>>, TError,{id: string;data: NonReadonly<User>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserControllerUser>>, TError,{id: string;data: NonReadonly<User>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseUserControllerUser>>, {id: string;data: NonReadonly<User>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseUserControllerUser(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseUserControllerUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseUserControllerUser>>>
    export type UpdateOneBaseUserControllerUserMutationBody = NonReadonly<User>
    export type UpdateOneBaseUserControllerUserMutationError = AxiosError<unknown>

    /**
 * @summary Update a single User
 */
export const useUpdateOneBaseUserControllerUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserControllerUser>>, TError,{id: string;data: NonReadonly<User>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseUserControllerUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single User
 */
export const getOneBaseUserControllerUser = (
    id: string,
    params?: GetOneBaseUserControllerUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    return axios.get(
      `/user/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseUserControllerUserQueryKey = (id: string,
    params?: GetOneBaseUserControllerUserParams,) => {
    return [`/user/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseUserControllerUserQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUser>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseUserControllerUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseUserControllerUserQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseUserControllerUser>>> = ({ signal }) => getOneBaseUserControllerUser(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseUserControllerUserQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseUserControllerUser>>>
export type GetOneBaseUserControllerUserQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single User
 */
export const useGetOneBaseUserControllerUser = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUser>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseUserControllerUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseUserControllerUserQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single User
 */
export const deleteOneBaseUserControllerUser = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/user/${id}`,options
    );
  }



export const getDeleteOneBaseUserControllerUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserControllerUser>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserControllerUser>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseUserControllerUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseUserControllerUser(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseUserControllerUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseUserControllerUser>>>
    
    export type DeleteOneBaseUserControllerUserMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single User
 */
export const useDeleteOneBaseUserControllerUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserControllerUser>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseUserControllerUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const userControllerMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    
    return axios.get(
      `/user/me`,options
    );
  }


export const getUserControllerMeQueryKey = () => {
    return [`/user/me`] as const;
    }

    
export const getUserControllerMeQueryOptions = <TData = Awaited<ReturnType<typeof userControllerMe>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerMe>>> = ({ signal }) => userControllerMe({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData> & { queryKey: QueryKey }
}

export type UserControllerMeQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerMe>>>
export type UserControllerMeQueryError = AxiosError<unknown>

export const useUserControllerMe = <TData = Awaited<ReturnType<typeof userControllerMe>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getUserControllerMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single UserSignature
 */
export const createOneBaseUserSignatureControllerUserSignature = (
    userSignature: NonReadonly<UserSignature>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSignature>> => {
    
    return axios.post(
      `/user-signature`,
      userSignature,options
    );
  }



export const getCreateOneBaseUserSignatureControllerUserSignatureMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserSignatureControllerUserSignature>>, TError,{data: NonReadonly<UserSignature>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserSignatureControllerUserSignature>>, TError,{data: NonReadonly<UserSignature>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseUserSignatureControllerUserSignature>>, {data: NonReadonly<UserSignature>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseUserSignatureControllerUserSignature(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseUserSignatureControllerUserSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseUserSignatureControllerUserSignature>>>
    export type CreateOneBaseUserSignatureControllerUserSignatureMutationBody = NonReadonly<UserSignature>
    export type CreateOneBaseUserSignatureControllerUserSignatureMutationError = AxiosError<unknown>

    /**
 * @summary Create a single UserSignature
 */
export const useCreateOneBaseUserSignatureControllerUserSignature = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseUserSignatureControllerUserSignature>>, TError,{data: NonReadonly<UserSignature>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseUserSignatureControllerUserSignatureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple UserSignatures
 */
export const getManyBaseUserSignatureControllerUserSignature = (
    params?: GetManyBaseUserSignatureControllerUserSignatureParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyUserSignatureResponseDto>> => {
    
    return axios.get(
      `/user-signature`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseUserSignatureControllerUserSignatureQueryKey = (params?: GetManyBaseUserSignatureControllerUserSignatureParams,) => {
    return [`/user-signature`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseUserSignatureControllerUserSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>, TError = AxiosError<unknown>>(params?: GetManyBaseUserSignatureControllerUserSignatureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseUserSignatureControllerUserSignatureQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>> = ({ signal }) => getManyBaseUserSignatureControllerUserSignature(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseUserSignatureControllerUserSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>>
export type GetManyBaseUserSignatureControllerUserSignatureQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple UserSignatures
 */
export const useGetManyBaseUserSignatureControllerUserSignature = <TData = Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseUserSignatureControllerUserSignatureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserSignatureControllerUserSignature>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseUserSignatureControllerUserSignatureQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single UserSignature
 */
export const updateOneBaseUserSignatureControllerUserSignature = (
    id: string,
    userSignature: NonReadonly<UserSignature>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSignature>> => {
    
    return axios.patch(
      `/user-signature/${id}`,
      userSignature,options
    );
  }



export const getUpdateOneBaseUserSignatureControllerUserSignatureMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserSignatureControllerUserSignature>>, TError,{id: string;data: NonReadonly<UserSignature>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserSignatureControllerUserSignature>>, TError,{id: string;data: NonReadonly<UserSignature>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseUserSignatureControllerUserSignature>>, {id: string;data: NonReadonly<UserSignature>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseUserSignatureControllerUserSignature(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseUserSignatureControllerUserSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseUserSignatureControllerUserSignature>>>
    export type UpdateOneBaseUserSignatureControllerUserSignatureMutationBody = NonReadonly<UserSignature>
    export type UpdateOneBaseUserSignatureControllerUserSignatureMutationError = AxiosError<unknown>

    /**
 * @summary Update a single UserSignature
 */
export const useUpdateOneBaseUserSignatureControllerUserSignature = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseUserSignatureControllerUserSignature>>, TError,{id: string;data: NonReadonly<UserSignature>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseUserSignatureControllerUserSignatureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single UserSignature
 */
export const getOneBaseUserSignatureControllerUserSignature = (
    id: string,
    params?: GetOneBaseUserSignatureControllerUserSignatureParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSignature>> => {
    
    return axios.get(
      `/user-signature/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseUserSignatureControllerUserSignatureQueryKey = (id: string,
    params?: GetOneBaseUserSignatureControllerUserSignatureParams,) => {
    return [`/user-signature/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseUserSignatureControllerUserSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseUserSignatureControllerUserSignatureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseUserSignatureControllerUserSignatureQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>> = ({ signal }) => getOneBaseUserSignatureControllerUserSignature(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseUserSignatureControllerUserSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>>
export type GetOneBaseUserSignatureControllerUserSignatureQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single UserSignature
 */
export const useGetOneBaseUserSignatureControllerUserSignature = <TData = Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseUserSignatureControllerUserSignatureParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserSignatureControllerUserSignature>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseUserSignatureControllerUserSignatureQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single UserSignature
 */
export const deleteOneBaseUserSignatureControllerUserSignature = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/user-signature/${id}`,options
    );
  }



export const getDeleteOneBaseUserSignatureControllerUserSignatureMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserSignatureControllerUserSignature>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserSignatureControllerUserSignature>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseUserSignatureControllerUserSignature>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseUserSignatureControllerUserSignature(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseUserSignatureControllerUserSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseUserSignatureControllerUserSignature>>>
    
    export type DeleteOneBaseUserSignatureControllerUserSignatureMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single UserSignature
 */
export const useDeleteOneBaseUserSignatureControllerUserSignature = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseUserSignatureControllerUserSignature>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseUserSignatureControllerUserSignatureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerCloneContract = (
    cloneEContractDto: CloneEContractDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/clone-contract`,
      cloneEContractDto,options
    );
  }



export const getEContractControllerCloneContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerCloneContract>>, TError,{data: CloneEContractDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerCloneContract>>, TError,{data: CloneEContractDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerCloneContract>>, {data: CloneEContractDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerCloneContract(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerCloneContractMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerCloneContract>>>
    export type EContractControllerCloneContractMutationBody = CloneEContractDto
    export type EContractControllerCloneContractMutationError = AxiosError<unknown>

    export const useEContractControllerCloneContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerCloneContract>>, TError,{data: CloneEContractDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerCloneContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerVerifyId = (
    verifyIdDto: VerifyIdDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/verify-id`,
      verifyIdDto,options
    );
  }



export const getEContractControllerVerifyIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerVerifyId>>, TError,{data: VerifyIdDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerVerifyId>>, TError,{data: VerifyIdDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerVerifyId>>, {data: VerifyIdDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerVerifyId(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerVerifyIdMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerVerifyId>>>
    export type EContractControllerVerifyIdMutationBody = VerifyIdDto
    export type EContractControllerVerifyIdMutationError = AxiosError<unknown>

    export const useEContractControllerVerifyId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerVerifyId>>, TError,{data: VerifyIdDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerVerifyIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerRequestSmsOtp = (
    verifySmsDto: VerifySmsDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/request-sms-otp`,
      verifySmsDto,options
    );
  }



export const getEContractControllerRequestSmsOtpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerRequestSmsOtp>>, TError,{data: VerifySmsDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerRequestSmsOtp>>, TError,{data: VerifySmsDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerRequestSmsOtp>>, {data: VerifySmsDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerRequestSmsOtp(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerRequestSmsOtpMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerRequestSmsOtp>>>
    export type EContractControllerRequestSmsOtpMutationBody = VerifySmsDto
    export type EContractControllerRequestSmsOtpMutationError = AxiosError<unknown>

    export const useEContractControllerRequestSmsOtp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerRequestSmsOtp>>, TError,{data: VerifySmsDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerRequestSmsOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerInitESign = (
    verifySmsDto: VerifySmsDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/init-esign`,
      verifySmsDto,options
    );
  }



export const getEContractControllerInitESignMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerInitESign>>, TError,{data: VerifySmsDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerInitESign>>, TError,{data: VerifySmsDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerInitESign>>, {data: VerifySmsDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerInitESign(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerInitESignMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerInitESign>>>
    export type EContractControllerInitESignMutationBody = VerifySmsDto
    export type EContractControllerInitESignMutationError = AxiosError<unknown>

    export const useEContractControllerInitESign = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerInitESign>>, TError,{data: VerifySmsDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerInitESignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerOcrId = (
    verifyIdDto: VerifyIdDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/ocr-id`,
      verifyIdDto,options
    );
  }



export const getEContractControllerOcrIdMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerOcrId>>, TError,{data: VerifyIdDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerOcrId>>, TError,{data: VerifyIdDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerOcrId>>, {data: VerifyIdDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerOcrId(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerOcrIdMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerOcrId>>>
    export type EContractControllerOcrIdMutationBody = VerifyIdDto
    export type EContractControllerOcrIdMutationError = AxiosError<unknown>

    export const useEContractControllerOcrId = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerOcrId>>, TError,{data: VerifyIdDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerOcrIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerDownloadContract = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/e-contract/download-contract/${id}`,options
    );
  }


export const getEContractControllerDownloadContractQueryKey = (id: string,) => {
    return [`/e-contract/download-contract/${id}`] as const;
    }

    
export const getEContractControllerDownloadContractQueryOptions = <TData = Awaited<ReturnType<typeof eContractControllerDownloadContract>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerDownloadContract>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEContractControllerDownloadContractQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eContractControllerDownloadContract>>> = ({ signal }) => eContractControllerDownloadContract(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eContractControllerDownloadContract>>, TError, TData> & { queryKey: QueryKey }
}

export type EContractControllerDownloadContractQueryResult = NonNullable<Awaited<ReturnType<typeof eContractControllerDownloadContract>>>
export type EContractControllerDownloadContractQueryError = AxiosError<unknown>

export const useEContractControllerDownloadContract = <TData = Awaited<ReturnType<typeof eContractControllerDownloadContract>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerDownloadContract>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEContractControllerDownloadContractQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const eContractControllerEContractStatuses = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/e-contract/e-contract-statuses`,options
    );
  }


export const getEContractControllerEContractStatusesQueryKey = () => {
    return [`/e-contract/e-contract-statuses`] as const;
    }

    
export const getEContractControllerEContractStatusesQueryOptions = <TData = Awaited<ReturnType<typeof eContractControllerEContractStatuses>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerEContractStatuses>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEContractControllerEContractStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eContractControllerEContractStatuses>>> = ({ signal }) => eContractControllerEContractStatuses({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eContractControllerEContractStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type EContractControllerEContractStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof eContractControllerEContractStatuses>>>
export type EContractControllerEContractStatusesQueryError = AxiosError<unknown>

export const useEContractControllerEContractStatuses = <TData = Awaited<ReturnType<typeof eContractControllerEContractStatuses>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerEContractStatuses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEContractControllerEContractStatusesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const eContractControllerPreviewSignedContract = (
    signEContractDto: NonReadonly<SignEContractDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/preview-signed-contract`,
      signEContractDto,options
    );
  }



export const getEContractControllerPreviewSignedContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerPreviewSignedContract>>, TError,{data: NonReadonly<SignEContractDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerPreviewSignedContract>>, TError,{data: NonReadonly<SignEContractDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerPreviewSignedContract>>, {data: NonReadonly<SignEContractDto>}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerPreviewSignedContract(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerPreviewSignedContractMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerPreviewSignedContract>>>
    export type EContractControllerPreviewSignedContractMutationBody = NonReadonly<SignEContractDto>
    export type EContractControllerPreviewSignedContractMutationError = AxiosError<unknown>

    export const useEContractControllerPreviewSignedContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerPreviewSignedContract>>, TError,{data: NonReadonly<SignEContractDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerPreviewSignedContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerSendToSign = (
    sendToSignDto: NonReadonly<SendToSignDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/send-to-sign`,
      sendToSignDto,options
    );
  }



export const getEContractControllerSendToSignMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerSendToSign>>, {data: NonReadonly<SendToSignDto>}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerSendToSign(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerSendToSignMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerSendToSign>>>
    export type EContractControllerSendToSignMutationBody = NonReadonly<SendToSignDto>
    export type EContractControllerSendToSignMutationError = AxiosError<unknown>

    export const useEContractControllerSendToSign = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerSendToSignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerSignContractWithEKYC = (
    signEContractDto: NonReadonly<SignEContractDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/sign-contract-ekyc`,
      signEContractDto,options
    );
  }



export const getEContractControllerSignContractWithEKYCMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSignContractWithEKYC>>, TError,{data: NonReadonly<SignEContractDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSignContractWithEKYC>>, TError,{data: NonReadonly<SignEContractDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerSignContractWithEKYC>>, {data: NonReadonly<SignEContractDto>}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerSignContractWithEKYC(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerSignContractWithEKYCMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerSignContractWithEKYC>>>
    export type EContractControllerSignContractWithEKYCMutationBody = NonReadonly<SignEContractDto>
    export type EContractControllerSignContractWithEKYCMutationError = AxiosError<unknown>

    export const useEContractControllerSignContractWithEKYC = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerSignContractWithEKYC>>, TError,{data: NonReadonly<SignEContractDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerSignContractWithEKYCMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractControllerCheckEContractExistBefore = (
    code: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/e-contract/check/${code}`,options
    );
  }


export const getEContractControllerCheckEContractExistBeforeQueryKey = (code: string,) => {
    return [`/e-contract/check/${code}`] as const;
    }

    
export const getEContractControllerCheckEContractExistBeforeQueryOptions = <TData = Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>, TError = AxiosError<unknown>>(code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEContractControllerCheckEContractExistBeforeQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>> = ({ signal }) => eContractControllerCheckEContractExistBefore(code, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>, TError, TData> & { queryKey: QueryKey }
}

export type EContractControllerCheckEContractExistBeforeQueryResult = NonNullable<Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>>
export type EContractControllerCheckEContractExistBeforeQueryError = AxiosError<unknown>

export const useEContractControllerCheckEContractExistBefore = <TData = Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>, TError = AxiosError<unknown>>(
 code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerCheckEContractExistBefore>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEContractControllerCheckEContractExistBeforeQueryOptions(code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const eContractControllerGetOne = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContract>> => {
    
    return axios.get(
      `/e-contract/get-one/${id}`,options
    );
  }


export const getEContractControllerGetOneQueryKey = (id: string,) => {
    return [`/e-contract/get-one/${id}`] as const;
    }

    
export const getEContractControllerGetOneQueryOptions = <TData = Awaited<ReturnType<typeof eContractControllerGetOne>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerGetOne>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEContractControllerGetOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof eContractControllerGetOne>>> = ({ signal }) => eContractControllerGetOne(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eContractControllerGetOne>>, TError, TData> & { queryKey: QueryKey }
}

export type EContractControllerGetOneQueryResult = NonNullable<Awaited<ReturnType<typeof eContractControllerGetOne>>>
export type EContractControllerGetOneQueryError = AxiosError<unknown>

export const useEContractControllerGetOne = <TData = Awaited<ReturnType<typeof eContractControllerGetOne>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof eContractControllerGetOne>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEContractControllerGetOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single EContract
 */
export const createOneBaseEContractControllerEContract = (
    createEContractDto: CreateEContractDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContract>> => {
    
    return axios.post(
      `/e-contract`,
      createEContractDto,options
    );
  }



export const getCreateOneBaseEContractControllerEContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractControllerEContract>>, TError,{data: CreateEContractDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractControllerEContract>>, TError,{data: CreateEContractDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseEContractControllerEContract>>, {data: CreateEContractDto}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseEContractControllerEContract(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseEContractControllerEContractMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseEContractControllerEContract>>>
    export type CreateOneBaseEContractControllerEContractMutationBody = CreateEContractDto
    export type CreateOneBaseEContractControllerEContractMutationError = AxiosError<unknown>

    /**
 * @summary Create a single EContract
 */
export const useCreateOneBaseEContractControllerEContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractControllerEContract>>, TError,{data: CreateEContractDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseEContractControllerEContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple EContracts
 */
export const getManyBaseEContractControllerEContract = (
    params?: GetManyBaseEContractControllerEContractParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyEContractResponseDto>> => {
    
    return axios.get(
      `/e-contract`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseEContractControllerEContractQueryKey = (params?: GetManyBaseEContractControllerEContractParams,) => {
    return [`/e-contract`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseEContractControllerEContractQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>, TError = AxiosError<unknown>>(params?: GetManyBaseEContractControllerEContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseEContractControllerEContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>> = ({ signal }) => getManyBaseEContractControllerEContract(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseEContractControllerEContractQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>>
export type GetManyBaseEContractControllerEContractQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple EContracts
 */
export const useGetManyBaseEContractControllerEContract = <TData = Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseEContractControllerEContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractControllerEContract>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseEContractControllerEContractQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const eContractControllerUpdateEContractWithEContractSignees = (
    updateEContractWithSigneesDto: UpdateEContractWithSigneesDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/e-contract/update-contract-with-signees`,
      updateEContractWithSigneesDto,options
    );
  }



export const getEContractControllerUpdateEContractWithEContractSigneesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerUpdateEContractWithEContractSignees>>, TError,{data: UpdateEContractWithSigneesDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractControllerUpdateEContractWithEContractSignees>>, TError,{data: UpdateEContractWithSigneesDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractControllerUpdateEContractWithEContractSignees>>, {data: UpdateEContractWithSigneesDto}> = (props) => {
          const {data} = props ?? {};

          return  eContractControllerUpdateEContractWithEContractSignees(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractControllerUpdateEContractWithEContractSigneesMutationResult = NonNullable<Awaited<ReturnType<typeof eContractControllerUpdateEContractWithEContractSignees>>>
    export type EContractControllerUpdateEContractWithEContractSigneesMutationBody = UpdateEContractWithSigneesDto
    export type EContractControllerUpdateEContractWithEContractSigneesMutationError = AxiosError<unknown>

    export const useEContractControllerUpdateEContractWithEContractSignees = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractControllerUpdateEContractWithEContractSignees>>, TError,{data: UpdateEContractWithSigneesDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractControllerUpdateEContractWithEContractSigneesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update a single EContract
 */
export const updateOneBaseEContractControllerEContract = (
    id: string,
    updateEContract: NonReadonly<UpdateEContract>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContract>> => {
    
    return axios.patch(
      `/e-contract/${id}`,
      updateEContract,options
    );
  }



export const getUpdateOneBaseEContractControllerEContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractControllerEContract>>, TError,{id: string;data: NonReadonly<UpdateEContract>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractControllerEContract>>, TError,{id: string;data: NonReadonly<UpdateEContract>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseEContractControllerEContract>>, {id: string;data: NonReadonly<UpdateEContract>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseEContractControllerEContract(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseEContractControllerEContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseEContractControllerEContract>>>
    export type UpdateOneBaseEContractControllerEContractMutationBody = NonReadonly<UpdateEContract>
    export type UpdateOneBaseEContractControllerEContractMutationError = AxiosError<unknown>

    /**
 * @summary Update a single EContract
 */
export const useUpdateOneBaseEContractControllerEContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractControllerEContract>>, TError,{id: string;data: NonReadonly<UpdateEContract>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseEContractControllerEContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single EContract
 */
export const getOneBaseEContractControllerEContract = (
    id: string,
    params?: GetOneBaseEContractControllerEContractParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContract>> => {
    
    return axios.get(
      `/e-contract/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseEContractControllerEContractQueryKey = (id: string,
    params?: GetOneBaseEContractControllerEContractParams,) => {
    return [`/e-contract/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseEContractControllerEContractQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseEContractControllerEContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseEContractControllerEContractQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>> = ({ signal }) => getOneBaseEContractControllerEContract(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseEContractControllerEContractQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>>
export type GetOneBaseEContractControllerEContractQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single EContract
 */
export const useGetOneBaseEContractControllerEContract = <TData = Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseEContractControllerEContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractControllerEContract>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseEContractControllerEContractQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single EContract
 */
export const deleteOneBaseEContractControllerEContract = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/e-contract/${id}`,options
    );
  }



export const getDeleteOneBaseEContractControllerEContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractControllerEContract>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractControllerEContract>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseEContractControllerEContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseEContractControllerEContract(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseEContractControllerEContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseEContractControllerEContract>>>
    
    export type DeleteOneBaseEContractControllerEContractMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single EContract
 */
export const useDeleteOneBaseEContractControllerEContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractControllerEContract>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseEContractControllerEContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Upload a file
 */
export const fileStorageControllerUploadFile = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/upload-file`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFile(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>>
    export type FileStorageControllerUploadFileMutationBody = FileUploadDTO
    export type FileStorageControllerUploadFileMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Upload multi files
 */
export const fileStorageControllerUploadFiles = (
    filesUploadDTO: FilesUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
filesUploadDTO.files.forEach(value => formData.append('files', value));

    
    return axios.post(
      `/upload-files`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFilesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, {data: FilesUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFiles(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFilesMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>>
    export type FileStorageControllerUploadFilesMutationBody = FilesUploadDTO
    export type FileStorageControllerUploadFilesMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFiles = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single EContractSignee
 */
export const createOneBaseEContractSigneeControllerEContractSignee = (
    eContractSignee: NonReadonly<EContractSignee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractSignee>> => {
    
    return axios.post(
      `/e-contract-signee`,
      eContractSignee,options
    );
  }



export const getCreateOneBaseEContractSigneeControllerEContractSigneeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractSigneeControllerEContractSignee>>, TError,{data: NonReadonly<EContractSignee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractSigneeControllerEContractSignee>>, TError,{data: NonReadonly<EContractSignee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseEContractSigneeControllerEContractSignee>>, {data: NonReadonly<EContractSignee>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseEContractSigneeControllerEContractSignee(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseEContractSigneeControllerEContractSigneeMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseEContractSigneeControllerEContractSignee>>>
    export type CreateOneBaseEContractSigneeControllerEContractSigneeMutationBody = NonReadonly<EContractSignee>
    export type CreateOneBaseEContractSigneeControllerEContractSigneeMutationError = AxiosError<unknown>

    /**
 * @summary Create a single EContractSignee
 */
export const useCreateOneBaseEContractSigneeControllerEContractSignee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractSigneeControllerEContractSignee>>, TError,{data: NonReadonly<EContractSignee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseEContractSigneeControllerEContractSigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple EContractSignees
 */
export const getManyBaseEContractSigneeControllerEContractSignee = (
    params?: GetManyBaseEContractSigneeControllerEContractSigneeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyEContractSigneeResponseDto>> => {
    
    return axios.get(
      `/e-contract-signee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseEContractSigneeControllerEContractSigneeQueryKey = (params?: GetManyBaseEContractSigneeControllerEContractSigneeParams,) => {
    return [`/e-contract-signee`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseEContractSigneeControllerEContractSigneeQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>, TError = AxiosError<unknown>>(params?: GetManyBaseEContractSigneeControllerEContractSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseEContractSigneeControllerEContractSigneeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>> = ({ signal }) => getManyBaseEContractSigneeControllerEContractSignee(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseEContractSigneeControllerEContractSigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>>
export type GetManyBaseEContractSigneeControllerEContractSigneeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple EContractSignees
 */
export const useGetManyBaseEContractSigneeControllerEContractSignee = <TData = Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseEContractSigneeControllerEContractSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractSigneeControllerEContractSignee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseEContractSigneeControllerEContractSigneeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single EContractSignee
 */
export const updateOneBaseEContractSigneeControllerEContractSignee = (
    id: string,
    eContractSignee: NonReadonly<EContractSignee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractSignee>> => {
    
    return axios.patch(
      `/e-contract-signee/${id}`,
      eContractSignee,options
    );
  }



export const getUpdateOneBaseEContractSigneeControllerEContractSigneeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string;data: NonReadonly<EContractSignee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string;data: NonReadonly<EContractSignee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseEContractSigneeControllerEContractSignee>>, {id: string;data: NonReadonly<EContractSignee>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseEContractSigneeControllerEContractSignee(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseEContractSigneeControllerEContractSigneeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseEContractSigneeControllerEContractSignee>>>
    export type UpdateOneBaseEContractSigneeControllerEContractSigneeMutationBody = NonReadonly<EContractSignee>
    export type UpdateOneBaseEContractSigneeControllerEContractSigneeMutationError = AxiosError<unknown>

    /**
 * @summary Update a single EContractSignee
 */
export const useUpdateOneBaseEContractSigneeControllerEContractSignee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string;data: NonReadonly<EContractSignee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseEContractSigneeControllerEContractSigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single EContractSignee
 */
export const getOneBaseEContractSigneeControllerEContractSignee = (
    id: string,
    params?: GetOneBaseEContractSigneeControllerEContractSigneeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractSignee>> => {
    
    return axios.get(
      `/e-contract-signee/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseEContractSigneeControllerEContractSigneeQueryKey = (id: string,
    params?: GetOneBaseEContractSigneeControllerEContractSigneeParams,) => {
    return [`/e-contract-signee/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseEContractSigneeControllerEContractSigneeQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseEContractSigneeControllerEContractSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseEContractSigneeControllerEContractSigneeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>> = ({ signal }) => getOneBaseEContractSigneeControllerEContractSignee(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseEContractSigneeControllerEContractSigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>>
export type GetOneBaseEContractSigneeControllerEContractSigneeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single EContractSignee
 */
export const useGetOneBaseEContractSigneeControllerEContractSignee = <TData = Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseEContractSigneeControllerEContractSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractSigneeControllerEContractSignee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseEContractSigneeControllerEContractSigneeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single EContractSignee
 */
export const deleteOneBaseEContractSigneeControllerEContractSignee = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/e-contract-signee/${id}`,options
    );
  }



export const getDeleteOneBaseEContractSigneeControllerEContractSigneeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseEContractSigneeControllerEContractSignee>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseEContractSigneeControllerEContractSignee(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseEContractSigneeControllerEContractSigneeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseEContractSigneeControllerEContractSignee>>>
    
    export type DeleteOneBaseEContractSigneeControllerEContractSigneeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single EContractSignee
 */
export const useDeleteOneBaseEContractSigneeControllerEContractSignee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEContractSigneeControllerEContractSignee>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseEContractSigneeControllerEContractSigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single EContractTracking
 */
export const createOneBaseEContractTrackingControllerEContractTracking = (
    eContractTracking: NonReadonly<EContractTracking>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractTracking>> => {
    
    return axios.post(
      `/e-contract-tracking`,
      eContractTracking,options
    );
  }



export const getCreateOneBaseEContractTrackingControllerEContractTrackingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractTrackingControllerEContractTracking>>, TError,{data: NonReadonly<EContractTracking>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractTrackingControllerEContractTracking>>, TError,{data: NonReadonly<EContractTracking>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseEContractTrackingControllerEContractTracking>>, {data: NonReadonly<EContractTracking>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseEContractTrackingControllerEContractTracking(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseEContractTrackingControllerEContractTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseEContractTrackingControllerEContractTracking>>>
    export type CreateOneBaseEContractTrackingControllerEContractTrackingMutationBody = NonReadonly<EContractTracking>
    export type CreateOneBaseEContractTrackingControllerEContractTrackingMutationError = AxiosError<unknown>

    /**
 * @summary Create a single EContractTracking
 */
export const useCreateOneBaseEContractTrackingControllerEContractTracking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEContractTrackingControllerEContractTracking>>, TError,{data: NonReadonly<EContractTracking>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseEContractTrackingControllerEContractTrackingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple EContractTrackings
 */
export const getManyBaseEContractTrackingControllerEContractTracking = (
    params?: GetManyBaseEContractTrackingControllerEContractTrackingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyEContractTrackingResponseDto>> => {
    
    return axios.get(
      `/e-contract-tracking`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseEContractTrackingControllerEContractTrackingQueryKey = (params?: GetManyBaseEContractTrackingControllerEContractTrackingParams,) => {
    return [`/e-contract-tracking`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseEContractTrackingControllerEContractTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>, TError = AxiosError<unknown>>(params?: GetManyBaseEContractTrackingControllerEContractTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseEContractTrackingControllerEContractTrackingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>> = ({ signal }) => getManyBaseEContractTrackingControllerEContractTracking(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseEContractTrackingControllerEContractTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>>
export type GetManyBaseEContractTrackingControllerEContractTrackingQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple EContractTrackings
 */
export const useGetManyBaseEContractTrackingControllerEContractTracking = <TData = Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseEContractTrackingControllerEContractTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEContractTrackingControllerEContractTracking>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseEContractTrackingControllerEContractTrackingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single EContractTracking
 */
export const updateOneBaseEContractTrackingControllerEContractTracking = (
    id: string,
    eContractTracking: NonReadonly<EContractTracking>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractTracking>> => {
    
    return axios.patch(
      `/e-contract-tracking/${id}`,
      eContractTracking,options
    );
  }



export const getUpdateOneBaseEContractTrackingControllerEContractTrackingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractTrackingControllerEContractTracking>>, TError,{id: string;data: NonReadonly<EContractTracking>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractTrackingControllerEContractTracking>>, TError,{id: string;data: NonReadonly<EContractTracking>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseEContractTrackingControllerEContractTracking>>, {id: string;data: NonReadonly<EContractTracking>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseEContractTrackingControllerEContractTracking(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseEContractTrackingControllerEContractTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseEContractTrackingControllerEContractTracking>>>
    export type UpdateOneBaseEContractTrackingControllerEContractTrackingMutationBody = NonReadonly<EContractTracking>
    export type UpdateOneBaseEContractTrackingControllerEContractTrackingMutationError = AxiosError<unknown>

    /**
 * @summary Update a single EContractTracking
 */
export const useUpdateOneBaseEContractTrackingControllerEContractTracking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEContractTrackingControllerEContractTracking>>, TError,{id: string;data: NonReadonly<EContractTracking>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseEContractTrackingControllerEContractTrackingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single EContractTracking
 */
export const getOneBaseEContractTrackingControllerEContractTracking = (
    id: string,
    params?: GetOneBaseEContractTrackingControllerEContractTrackingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EContractTracking>> => {
    
    return axios.get(
      `/e-contract-tracking/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseEContractTrackingControllerEContractTrackingQueryKey = (id: string,
    params?: GetOneBaseEContractTrackingControllerEContractTrackingParams,) => {
    return [`/e-contract-tracking/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseEContractTrackingControllerEContractTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseEContractTrackingControllerEContractTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseEContractTrackingControllerEContractTrackingQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>> = ({ signal }) => getOneBaseEContractTrackingControllerEContractTracking(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseEContractTrackingControllerEContractTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>>
export type GetOneBaseEContractTrackingControllerEContractTrackingQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single EContractTracking
 */
export const useGetOneBaseEContractTrackingControllerEContractTracking = <TData = Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseEContractTrackingControllerEContractTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEContractTrackingControllerEContractTracking>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseEContractTrackingControllerEContractTrackingQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upload multi files
 */
export const massContractControllerUploadFiles = (
    clientId: string,
    filesUploadDTO: FilesUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
filesUploadDTO.files.forEach(value => formData.append('files', value));

    
    return axios.post(
      `/mass-contract/upload-files/${clientId}`,
      formData,options
    );
  }



export const getMassContractControllerUploadFilesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUploadFiles>>, TError,{clientId: string;data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUploadFiles>>, TError,{clientId: string;data: FilesUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof massContractControllerUploadFiles>>, {clientId: string;data: FilesUploadDTO}> = (props) => {
          const {clientId,data} = props ?? {};

          return  massContractControllerUploadFiles(clientId,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MassContractControllerUploadFilesMutationResult = NonNullable<Awaited<ReturnType<typeof massContractControllerUploadFiles>>>
    export type MassContractControllerUploadFilesMutationBody = FilesUploadDTO
    export type MassContractControllerUploadFilesMutationError = AxiosError<unknown>

    export const useMassContractControllerUploadFiles = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUploadFiles>>, TError,{clientId: string;data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMassContractControllerUploadFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const massContractControllerUpdateMassContractAndEContractSignees = (
    updateMassEContractWithSigneesDto: NonReadonly<UpdateMassEContractWithSigneesDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.patch(
      `/mass-contract/update-mass-with-signees`,
      updateMassEContractWithSigneesDto,options
    );
  }



export const getMassContractControllerUpdateMassContractAndEContractSigneesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUpdateMassContractAndEContractSignees>>, TError,{data: NonReadonly<UpdateMassEContractWithSigneesDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUpdateMassContractAndEContractSignees>>, TError,{data: NonReadonly<UpdateMassEContractWithSigneesDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof massContractControllerUpdateMassContractAndEContractSignees>>, {data: NonReadonly<UpdateMassEContractWithSigneesDto>}> = (props) => {
          const {data} = props ?? {};

          return  massContractControllerUpdateMassContractAndEContractSignees(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MassContractControllerUpdateMassContractAndEContractSigneesMutationResult = NonNullable<Awaited<ReturnType<typeof massContractControllerUpdateMassContractAndEContractSignees>>>
    export type MassContractControllerUpdateMassContractAndEContractSigneesMutationBody = NonReadonly<UpdateMassEContractWithSigneesDto>
    export type MassContractControllerUpdateMassContractAndEContractSigneesMutationError = AxiosError<unknown>

    export const useMassContractControllerUpdateMassContractAndEContractSignees = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerUpdateMassContractAndEContractSignees>>, TError,{data: NonReadonly<UpdateMassEContractWithSigneesDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMassContractControllerUpdateMassContractAndEContractSigneesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const massContractControllerSendToSign = (
    sendToSignMassDto: NonReadonly<SendToSignMassDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/mass-contract/send-to-sign`,
      sendToSignMassDto,options
    );
  }



export const getMassContractControllerSendToSignMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignMassDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof massContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignMassDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof massContractControllerSendToSign>>, {data: NonReadonly<SendToSignMassDto>}> = (props) => {
          const {data} = props ?? {};

          return  massContractControllerSendToSign(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MassContractControllerSendToSignMutationResult = NonNullable<Awaited<ReturnType<typeof massContractControllerSendToSign>>>
    export type MassContractControllerSendToSignMutationBody = NonReadonly<SendToSignMassDto>
    export type MassContractControllerSendToSignMutationError = AxiosError<unknown>

    export const useMassContractControllerSendToSign = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof massContractControllerSendToSign>>, TError,{data: NonReadonly<SendToSignMassDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMassContractControllerSendToSignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single MassContract
 */
export const createOneBaseMassContractControllerMassContract = (
    createMassEContractDto: NonReadonly<CreateMassEContractDto>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContract>> => {
    
    return axios.post(
      `/mass-contract`,
      createMassEContractDto,options
    );
  }



export const getCreateOneBaseMassContractControllerMassContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractControllerMassContract>>, TError,{data: NonReadonly<CreateMassEContractDto>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractControllerMassContract>>, TError,{data: NonReadonly<CreateMassEContractDto>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseMassContractControllerMassContract>>, {data: NonReadonly<CreateMassEContractDto>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseMassContractControllerMassContract(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseMassContractControllerMassContractMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseMassContractControllerMassContract>>>
    export type CreateOneBaseMassContractControllerMassContractMutationBody = NonReadonly<CreateMassEContractDto>
    export type CreateOneBaseMassContractControllerMassContractMutationError = AxiosError<unknown>

    /**
 * @summary Create a single MassContract
 */
export const useCreateOneBaseMassContractControllerMassContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractControllerMassContract>>, TError,{data: NonReadonly<CreateMassEContractDto>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseMassContractControllerMassContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple MassContracts
 */
export const getManyBaseMassContractControllerMassContract = (
    params?: GetManyBaseMassContractControllerMassContractParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyMassContractResponseDto>> => {
    
    return axios.get(
      `/mass-contract`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseMassContractControllerMassContractQueryKey = (params?: GetManyBaseMassContractControllerMassContractParams,) => {
    return [`/mass-contract`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseMassContractControllerMassContractQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>, TError = AxiosError<unknown>>(params?: GetManyBaseMassContractControllerMassContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseMassContractControllerMassContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>> = ({ signal }) => getManyBaseMassContractControllerMassContract(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseMassContractControllerMassContractQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>>
export type GetManyBaseMassContractControllerMassContractQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple MassContracts
 */
export const useGetManyBaseMassContractControllerMassContract = <TData = Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseMassContractControllerMassContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractControllerMassContract>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseMassContractControllerMassContractQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single MassContract
 */
export const updateOneBaseMassContractControllerMassContract = (
    id: string,
    massContract: NonReadonly<MassContract>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContract>> => {
    
    return axios.patch(
      `/mass-contract/${id}`,
      massContract,options
    );
  }



export const getUpdateOneBaseMassContractControllerMassContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractControllerMassContract>>, TError,{id: string;data: NonReadonly<MassContract>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractControllerMassContract>>, TError,{id: string;data: NonReadonly<MassContract>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseMassContractControllerMassContract>>, {id: string;data: NonReadonly<MassContract>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseMassContractControllerMassContract(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseMassContractControllerMassContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseMassContractControllerMassContract>>>
    export type UpdateOneBaseMassContractControllerMassContractMutationBody = NonReadonly<MassContract>
    export type UpdateOneBaseMassContractControllerMassContractMutationError = AxiosError<unknown>

    /**
 * @summary Update a single MassContract
 */
export const useUpdateOneBaseMassContractControllerMassContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractControllerMassContract>>, TError,{id: string;data: NonReadonly<MassContract>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseMassContractControllerMassContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single MassContract
 */
export const getOneBaseMassContractControllerMassContract = (
    id: string,
    params?: GetOneBaseMassContractControllerMassContractParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContract>> => {
    
    return axios.get(
      `/mass-contract/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseMassContractControllerMassContractQueryKey = (id: string,
    params?: GetOneBaseMassContractControllerMassContractParams,) => {
    return [`/mass-contract/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseMassContractControllerMassContractQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseMassContractControllerMassContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseMassContractControllerMassContractQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>> = ({ signal }) => getOneBaseMassContractControllerMassContract(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseMassContractControllerMassContractQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>>
export type GetOneBaseMassContractControllerMassContractQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single MassContract
 */
export const useGetOneBaseMassContractControllerMassContract = <TData = Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseMassContractControllerMassContractParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractControllerMassContract>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseMassContractControllerMassContractQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single MassContract
 */
export const deleteOneBaseMassContractControllerMassContract = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/mass-contract/${id}`,options
    );
  }



export const getDeleteOneBaseMassContractControllerMassContractMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseMassContractControllerMassContract>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseMassContractControllerMassContract>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseMassContractControllerMassContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseMassContractControllerMassContract(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseMassContractControllerMassContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseMassContractControllerMassContract>>>
    
    export type DeleteOneBaseMassContractControllerMassContractMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single MassContract
 */
export const useDeleteOneBaseMassContractControllerMassContract = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseMassContractControllerMassContract>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseMassContractControllerMassContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single MassContractItem
 */
export const getOneBaseMassContractItemControllerMassContractItem = (
    id: string,
    params?: GetOneBaseMassContractItemControllerMassContractItemParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItem>> => {
    
    return axios.get(
      `/mass-contract-item/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseMassContractItemControllerMassContractItemQueryKey = (id: string,
    params?: GetOneBaseMassContractItemControllerMassContractItemParams,) => {
    return [`/mass-contract-item/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseMassContractItemControllerMassContractItemQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseMassContractItemControllerMassContractItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseMassContractItemControllerMassContractItemQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>> = ({ signal }) => getOneBaseMassContractItemControllerMassContractItem(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseMassContractItemControllerMassContractItemQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>>
export type GetOneBaseMassContractItemControllerMassContractItemQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single MassContractItem
 */
export const useGetOneBaseMassContractItemControllerMassContractItem = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseMassContractItemControllerMassContractItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemControllerMassContractItem>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseMassContractItemControllerMassContractItemQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single MassContractItem
 */
export const updateOneBaseMassContractItemControllerMassContractItem = (
    id: string,
    massContractItem: NonReadonly<MassContractItem>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItem>> => {
    
    return axios.patch(
      `/mass-contract-item/${id}`,
      massContractItem,options
    );
  }



export const getUpdateOneBaseMassContractItemControllerMassContractItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemControllerMassContractItem>>, TError,{id: string;data: NonReadonly<MassContractItem>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemControllerMassContractItem>>, TError,{id: string;data: NonReadonly<MassContractItem>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseMassContractItemControllerMassContractItem>>, {id: string;data: NonReadonly<MassContractItem>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseMassContractItemControllerMassContractItem(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseMassContractItemControllerMassContractItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseMassContractItemControllerMassContractItem>>>
    export type UpdateOneBaseMassContractItemControllerMassContractItemMutationBody = NonReadonly<MassContractItem>
    export type UpdateOneBaseMassContractItemControllerMassContractItemMutationError = AxiosError<unknown>

    /**
 * @summary Update a single MassContractItem
 */
export const useUpdateOneBaseMassContractItemControllerMassContractItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemControllerMassContractItem>>, TError,{id: string;data: NonReadonly<MassContractItem>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseMassContractItemControllerMassContractItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple MassContractItems
 */
export const getManyBaseMassContractItemControllerMassContractItem = (
    params?: GetManyBaseMassContractItemControllerMassContractItemParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyMassContractItemResponseDto>> => {
    
    return axios.get(
      `/mass-contract-item`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseMassContractItemControllerMassContractItemQueryKey = (params?: GetManyBaseMassContractItemControllerMassContractItemParams,) => {
    return [`/mass-contract-item`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseMassContractItemControllerMassContractItemQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>, TError = AxiosError<unknown>>(params?: GetManyBaseMassContractItemControllerMassContractItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseMassContractItemControllerMassContractItemQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>> = ({ signal }) => getManyBaseMassContractItemControllerMassContractItem(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseMassContractItemControllerMassContractItemQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>>
export type GetManyBaseMassContractItemControllerMassContractItemQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple MassContractItems
 */
export const useGetManyBaseMassContractItemControllerMassContractItem = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseMassContractItemControllerMassContractItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemControllerMassContractItem>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseMassContractItemControllerMassContractItemQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single MassContractItem
 */
export const createOneBaseMassContractItemControllerMassContractItem = (
    massContractItem: NonReadonly<MassContractItem>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItem>> => {
    
    return axios.post(
      `/mass-contract-item`,
      massContractItem,options
    );
  }



export const getCreateOneBaseMassContractItemControllerMassContractItemMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemControllerMassContractItem>>, TError,{data: NonReadonly<MassContractItem>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemControllerMassContractItem>>, TError,{data: NonReadonly<MassContractItem>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseMassContractItemControllerMassContractItem>>, {data: NonReadonly<MassContractItem>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseMassContractItemControllerMassContractItem(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseMassContractItemControllerMassContractItemMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseMassContractItemControllerMassContractItem>>>
    export type CreateOneBaseMassContractItemControllerMassContractItemMutationBody = NonReadonly<MassContractItem>
    export type CreateOneBaseMassContractItemControllerMassContractItemMutationError = AxiosError<unknown>

    /**
 * @summary Create a single MassContractItem
 */
export const useCreateOneBaseMassContractItemControllerMassContractItem = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemControllerMassContractItem>>, TError,{data: NonReadonly<MassContractItem>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseMassContractItemControllerMassContractItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single MassContractItemSignee
 */
export const getOneBaseMassContractItemSigneeControllerMassContractItemSignee = (
    id: string,
    params?: GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemSignee>> => {
    
    return axios.get(
      `/mass-contract-item-signee/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryKey = (id: string,
    params?: GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeParams,) => {
    return [`/mass-contract-item-signee/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>> = ({ signal }) => getOneBaseMassContractItemSigneeControllerMassContractItemSignee(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>>
export type GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single MassContractItemSignee
 */
export const useGetOneBaseMassContractItemSigneeControllerMassContractItemSignee = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseMassContractItemSigneeControllerMassContractItemSigneeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single MassContractItemSignee
 */
export const updateOneBaseMassContractItemSigneeControllerMassContractItemSignee = (
    id: string,
    massContractItemSignee: NonReadonly<MassContractItemSignee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemSignee>> => {
    
    return axios.patch(
      `/mass-contract-item-signee/${id}`,
      massContractItemSignee,options
    );
  }



export const getUpdateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{id: string;data: NonReadonly<MassContractItemSignee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{id: string;data: NonReadonly<MassContractItemSignee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, {id: string;data: NonReadonly<MassContractItemSignee>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseMassContractItemSigneeControllerMassContractItemSignee(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseMassContractItemSigneeControllerMassContractItemSignee>>>
    export type UpdateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationBody = NonReadonly<MassContractItemSignee>
    export type UpdateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationError = AxiosError<unknown>

    /**
 * @summary Update a single MassContractItemSignee
 */
export const useUpdateOneBaseMassContractItemSigneeControllerMassContractItemSignee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{id: string;data: NonReadonly<MassContractItemSignee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple MassContractItemSignees
 */
export const getManyBaseMassContractItemSigneeControllerMassContractItemSignee = (
    params?: GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyMassContractItemSigneeResponseDto>> => {
    
    return axios.get(
      `/mass-contract-item-signee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryKey = (params?: GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeParams,) => {
    return [`/mass-contract-item-signee`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError = AxiosError<unknown>>(params?: GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>> = ({ signal }) => getManyBaseMassContractItemSigneeControllerMassContractItemSignee(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>>
export type GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple MassContractItemSignees
 */
export const useGetManyBaseMassContractItemSigneeControllerMassContractItemSignee = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseMassContractItemSigneeControllerMassContractItemSigneeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseMassContractItemSigneeControllerMassContractItemSigneeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single MassContractItemSignee
 */
export const createOneBaseMassContractItemSigneeControllerMassContractItemSignee = (
    massContractItemSignee: NonReadonly<MassContractItemSignee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemSignee>> => {
    
    return axios.post(
      `/mass-contract-item-signee`,
      massContractItemSignee,options
    );
  }



export const getCreateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{data: NonReadonly<MassContractItemSignee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{data: NonReadonly<MassContractItemSignee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, {data: NonReadonly<MassContractItemSignee>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseMassContractItemSigneeControllerMassContractItemSignee(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseMassContractItemSigneeControllerMassContractItemSignee>>>
    export type CreateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationBody = NonReadonly<MassContractItemSignee>
    export type CreateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationError = AxiosError<unknown>

    /**
 * @summary Create a single MassContractItemSignee
 */
export const useCreateOneBaseMassContractItemSigneeControllerMassContractItemSignee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemSigneeControllerMassContractItemSignee>>, TError,{data: NonReadonly<MassContractItemSignee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseMassContractItemSigneeControllerMassContractItemSigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single MassContractItemTracking
 */
export const getOneBaseMassContractItemTrackingControllerMassContractItemTracking = (
    id: string,
    params?: GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemTracking>> => {
    
    return axios.get(
      `/mass-contract-item-tracking/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryKey = (id: string,
    params?: GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingParams,) => {
    return [`/mass-contract-item-tracking/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>> = ({ signal }) => getOneBaseMassContractItemTrackingControllerMassContractItemTracking(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>>
export type GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single MassContractItemTracking
 */
export const useGetOneBaseMassContractItemTrackingControllerMassContractItemTracking = <TData = Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseMassContractItemTrackingControllerMassContractItemTrackingQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single MassContractItemTracking
 */
export const updateOneBaseMassContractItemTrackingControllerMassContractItemTracking = (
    id: string,
    massContractItemTracking: NonReadonly<MassContractItemTracking>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemTracking>> => {
    
    return axios.patch(
      `/mass-contract-item-tracking/${id}`,
      massContractItemTracking,options
    );
  }



export const getUpdateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{id: string;data: NonReadonly<MassContractItemTracking>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{id: string;data: NonReadonly<MassContractItemTracking>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, {id: string;data: NonReadonly<MassContractItemTracking>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseMassContractItemTrackingControllerMassContractItemTracking(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseMassContractItemTrackingControllerMassContractItemTracking>>>
    export type UpdateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationBody = NonReadonly<MassContractItemTracking>
    export type UpdateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationError = AxiosError<unknown>

    /**
 * @summary Update a single MassContractItemTracking
 */
export const useUpdateOneBaseMassContractItemTrackingControllerMassContractItemTracking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{id: string;data: NonReadonly<MassContractItemTracking>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple MassContractItemTrackings
 */
export const getManyBaseMassContractItemTrackingControllerMassContractItemTracking = (
    params?: GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyMassContractItemTrackingResponseDto>> => {
    
    return axios.get(
      `/mass-contract-item-tracking`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryKey = (params?: GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingParams,) => {
    return [`/mass-contract-item-tracking`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError = AxiosError<unknown>>(params?: GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>> = ({ signal }) => getManyBaseMassContractItemTrackingControllerMassContractItemTracking(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>>
export type GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple MassContractItemTrackings
 */
export const useGetManyBaseMassContractItemTrackingControllerMassContractItemTracking = <TData = Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseMassContractItemTrackingControllerMassContractItemTrackingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseMassContractItemTrackingControllerMassContractItemTrackingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single MassContractItemTracking
 */
export const createOneBaseMassContractItemTrackingControllerMassContractItemTracking = (
    massContractItemTracking: NonReadonly<MassContractItemTracking>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MassContractItemTracking>> => {
    
    return axios.post(
      `/mass-contract-item-tracking`,
      massContractItemTracking,options
    );
  }



export const getCreateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{data: NonReadonly<MassContractItemTracking>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{data: NonReadonly<MassContractItemTracking>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, {data: NonReadonly<MassContractItemTracking>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseMassContractItemTrackingControllerMassContractItemTracking(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseMassContractItemTrackingControllerMassContractItemTracking>>>
    export type CreateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationBody = NonReadonly<MassContractItemTracking>
    export type CreateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationError = AxiosError<unknown>

    /**
 * @summary Create a single MassContractItemTracking
 */
export const useCreateOneBaseMassContractItemTrackingControllerMassContractItemTracking = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseMassContractItemTrackingControllerMassContractItemTracking>>, TError,{data: NonReadonly<MassContractItemTracking>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseMassContractItemTrackingControllerMassContractItemTrackingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single DocumentType
 */
export const createOneBaseDocumentTypeControllerDocumentType = (
    documentType: NonReadonly<DocumentType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocumentType>> => {
    
    return axios.post(
      `/document-type`,
      documentType,options
    );
  }



export const getCreateOneBaseDocumentTypeControllerDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDocumentTypeControllerDocumentType>>, TError,{data: NonReadonly<DocumentType>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDocumentTypeControllerDocumentType>>, TError,{data: NonReadonly<DocumentType>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseDocumentTypeControllerDocumentType>>, {data: NonReadonly<DocumentType>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseDocumentTypeControllerDocumentType(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseDocumentTypeControllerDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseDocumentTypeControllerDocumentType>>>
    export type CreateOneBaseDocumentTypeControllerDocumentTypeMutationBody = NonReadonly<DocumentType>
    export type CreateOneBaseDocumentTypeControllerDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Create a single DocumentType
 */
export const useCreateOneBaseDocumentTypeControllerDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDocumentTypeControllerDocumentType>>, TError,{data: NonReadonly<DocumentType>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseDocumentTypeControllerDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple DocumentTypes
 */
export const getManyBaseDocumentTypeControllerDocumentType = (
    params?: GetManyBaseDocumentTypeControllerDocumentTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyDocumentTypeResponseDto>> => {
    
    return axios.get(
      `/document-type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseDocumentTypeControllerDocumentTypeQueryKey = (params?: GetManyBaseDocumentTypeControllerDocumentTypeParams,) => {
    return [`/document-type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseDocumentTypeControllerDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>, TError = AxiosError<unknown>>(params?: GetManyBaseDocumentTypeControllerDocumentTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseDocumentTypeControllerDocumentTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>> = ({ signal }) => getManyBaseDocumentTypeControllerDocumentType(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseDocumentTypeControllerDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>>
export type GetManyBaseDocumentTypeControllerDocumentTypeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple DocumentTypes
 */
export const useGetManyBaseDocumentTypeControllerDocumentType = <TData = Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseDocumentTypeControllerDocumentTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDocumentTypeControllerDocumentType>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseDocumentTypeControllerDocumentTypeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single DocumentType
 */
export const updateOneBaseDocumentTypeControllerDocumentType = (
    id: string,
    documentType: NonReadonly<DocumentType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocumentType>> => {
    
    return axios.patch(
      `/document-type/${id}`,
      documentType,options
    );
  }



export const getUpdateOneBaseDocumentTypeControllerDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string;data: NonReadonly<DocumentType>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string;data: NonReadonly<DocumentType>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseDocumentTypeControllerDocumentType>>, {id: string;data: NonReadonly<DocumentType>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseDocumentTypeControllerDocumentType(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseDocumentTypeControllerDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseDocumentTypeControllerDocumentType>>>
    export type UpdateOneBaseDocumentTypeControllerDocumentTypeMutationBody = NonReadonly<DocumentType>
    export type UpdateOneBaseDocumentTypeControllerDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Update a single DocumentType
 */
export const useUpdateOneBaseDocumentTypeControllerDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string;data: NonReadonly<DocumentType>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseDocumentTypeControllerDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single DocumentType
 */
export const getOneBaseDocumentTypeControllerDocumentType = (
    id: string,
    params?: GetOneBaseDocumentTypeControllerDocumentTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DocumentType>> => {
    
    return axios.get(
      `/document-type/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseDocumentTypeControllerDocumentTypeQueryKey = (id: string,
    params?: GetOneBaseDocumentTypeControllerDocumentTypeParams,) => {
    return [`/document-type/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseDocumentTypeControllerDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseDocumentTypeControllerDocumentTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseDocumentTypeControllerDocumentTypeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>> = ({ signal }) => getOneBaseDocumentTypeControllerDocumentType(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseDocumentTypeControllerDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>>
export type GetOneBaseDocumentTypeControllerDocumentTypeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single DocumentType
 */
export const useGetOneBaseDocumentTypeControllerDocumentType = <TData = Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseDocumentTypeControllerDocumentTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDocumentTypeControllerDocumentType>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseDocumentTypeControllerDocumentTypeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single DocumentType
 */
export const deleteOneBaseDocumentTypeControllerDocumentType = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/document-type/${id}`,options
    );
  }



export const getDeleteOneBaseDocumentTypeControllerDocumentTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseDocumentTypeControllerDocumentType>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseDocumentTypeControllerDocumentType(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseDocumentTypeControllerDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseDocumentTypeControllerDocumentType>>>
    
    export type DeleteOneBaseDocumentTypeControllerDocumentTypeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single DocumentType
 */
export const useDeleteOneBaseDocumentTypeControllerDocumentType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDocumentTypeControllerDocumentType>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseDocumentTypeControllerDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single ContractType
 */
export const createOneBaseContractTypeControllerContractType = (
    contractType: NonReadonly<ContractType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractType>> => {
    
    return axios.post(
      `/contract-type`,
      contractType,options
    );
  }



export const getCreateOneBaseContractTypeControllerContractTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseContractTypeControllerContractType>>, TError,{data: NonReadonly<ContractType>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseContractTypeControllerContractType>>, TError,{data: NonReadonly<ContractType>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseContractTypeControllerContractType>>, {data: NonReadonly<ContractType>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseContractTypeControllerContractType(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseContractTypeControllerContractTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseContractTypeControllerContractType>>>
    export type CreateOneBaseContractTypeControllerContractTypeMutationBody = NonReadonly<ContractType>
    export type CreateOneBaseContractTypeControllerContractTypeMutationError = AxiosError<unknown>

    /**
 * @summary Create a single ContractType
 */
export const useCreateOneBaseContractTypeControllerContractType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseContractTypeControllerContractType>>, TError,{data: NonReadonly<ContractType>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseContractTypeControllerContractTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple ContractTypes
 */
export const getManyBaseContractTypeControllerContractType = (
    params?: GetManyBaseContractTypeControllerContractTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyContractTypeResponseDto>> => {
    
    return axios.get(
      `/contract-type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseContractTypeControllerContractTypeQueryKey = (params?: GetManyBaseContractTypeControllerContractTypeParams,) => {
    return [`/contract-type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseContractTypeControllerContractTypeQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>, TError = AxiosError<unknown>>(params?: GetManyBaseContractTypeControllerContractTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseContractTypeControllerContractTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>> = ({ signal }) => getManyBaseContractTypeControllerContractType(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseContractTypeControllerContractTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>>
export type GetManyBaseContractTypeControllerContractTypeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple ContractTypes
 */
export const useGetManyBaseContractTypeControllerContractType = <TData = Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseContractTypeControllerContractTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseContractTypeControllerContractType>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseContractTypeControllerContractTypeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single ContractType
 */
export const updateOneBaseContractTypeControllerContractType = (
    id: string,
    contractType: NonReadonly<ContractType>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractType>> => {
    
    return axios.patch(
      `/contract-type/${id}`,
      contractType,options
    );
  }



export const getUpdateOneBaseContractTypeControllerContractTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseContractTypeControllerContractType>>, TError,{id: string;data: NonReadonly<ContractType>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseContractTypeControllerContractType>>, TError,{id: string;data: NonReadonly<ContractType>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseContractTypeControllerContractType>>, {id: string;data: NonReadonly<ContractType>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseContractTypeControllerContractType(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseContractTypeControllerContractTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseContractTypeControllerContractType>>>
    export type UpdateOneBaseContractTypeControllerContractTypeMutationBody = NonReadonly<ContractType>
    export type UpdateOneBaseContractTypeControllerContractTypeMutationError = AxiosError<unknown>

    /**
 * @summary Update a single ContractType
 */
export const useUpdateOneBaseContractTypeControllerContractType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseContractTypeControllerContractType>>, TError,{id: string;data: NonReadonly<ContractType>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseContractTypeControllerContractTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single ContractType
 */
export const getOneBaseContractTypeControllerContractType = (
    id: string,
    params?: GetOneBaseContractTypeControllerContractTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ContractType>> => {
    
    return axios.get(
      `/contract-type/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseContractTypeControllerContractTypeQueryKey = (id: string,
    params?: GetOneBaseContractTypeControllerContractTypeParams,) => {
    return [`/contract-type/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseContractTypeControllerContractTypeQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseContractTypeControllerContractTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseContractTypeControllerContractTypeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>> = ({ signal }) => getOneBaseContractTypeControllerContractType(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseContractTypeControllerContractTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>>
export type GetOneBaseContractTypeControllerContractTypeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ContractType
 */
export const useGetOneBaseContractTypeControllerContractType = <TData = Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseContractTypeControllerContractTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseContractTypeControllerContractType>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseContractTypeControllerContractTypeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single ContractType
 */
export const deleteOneBaseContractTypeControllerContractType = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/contract-type/${id}`,options
    );
  }



export const getDeleteOneBaseContractTypeControllerContractTypeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseContractTypeControllerContractType>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseContractTypeControllerContractType>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseContractTypeControllerContractType>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseContractTypeControllerContractType(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseContractTypeControllerContractTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseContractTypeControllerContractType>>>
    
    export type DeleteOneBaseContractTypeControllerContractTypeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single ContractType
 */
export const useDeleteOneBaseContractTypeControllerContractType = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseContractTypeControllerContractType>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseContractTypeControllerContractTypeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single Department
 */
export const createOneBaseDepartmentControllerDepartment = (
    department: NonReadonly<Department>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Department>> => {
    
    return axios.post(
      `/department`,
      department,options
    );
  }



export const getCreateOneBaseDepartmentControllerDepartmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDepartmentControllerDepartment>>, TError,{data: NonReadonly<Department>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDepartmentControllerDepartment>>, TError,{data: NonReadonly<Department>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseDepartmentControllerDepartment>>, {data: NonReadonly<Department>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseDepartmentControllerDepartment(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseDepartmentControllerDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseDepartmentControllerDepartment>>>
    export type CreateOneBaseDepartmentControllerDepartmentMutationBody = NonReadonly<Department>
    export type CreateOneBaseDepartmentControllerDepartmentMutationError = AxiosError<unknown>

    /**
 * @summary Create a single Department
 */
export const useCreateOneBaseDepartmentControllerDepartment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseDepartmentControllerDepartment>>, TError,{data: NonReadonly<Department>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseDepartmentControllerDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple Departments
 */
export const getManyBaseDepartmentControllerDepartment = (
    params?: GetManyBaseDepartmentControllerDepartmentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyDepartmentResponseDto>> => {
    
    return axios.get(
      `/department`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseDepartmentControllerDepartmentQueryKey = (params?: GetManyBaseDepartmentControllerDepartmentParams,) => {
    return [`/department`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseDepartmentControllerDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>, TError = AxiosError<unknown>>(params?: GetManyBaseDepartmentControllerDepartmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseDepartmentControllerDepartmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>> = ({ signal }) => getManyBaseDepartmentControllerDepartment(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseDepartmentControllerDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>>
export type GetManyBaseDepartmentControllerDepartmentQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple Departments
 */
export const useGetManyBaseDepartmentControllerDepartment = <TData = Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseDepartmentControllerDepartmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseDepartmentControllerDepartment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseDepartmentControllerDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single Department
 */
export const updateOneBaseDepartmentControllerDepartment = (
    id: string,
    department: NonReadonly<Department>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Department>> => {
    
    return axios.patch(
      `/department/${id}`,
      department,options
    );
  }



export const getUpdateOneBaseDepartmentControllerDepartmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDepartmentControllerDepartment>>, TError,{id: string;data: NonReadonly<Department>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDepartmentControllerDepartment>>, TError,{id: string;data: NonReadonly<Department>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseDepartmentControllerDepartment>>, {id: string;data: NonReadonly<Department>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseDepartmentControllerDepartment(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseDepartmentControllerDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseDepartmentControllerDepartment>>>
    export type UpdateOneBaseDepartmentControllerDepartmentMutationBody = NonReadonly<Department>
    export type UpdateOneBaseDepartmentControllerDepartmentMutationError = AxiosError<unknown>

    /**
 * @summary Update a single Department
 */
export const useUpdateOneBaseDepartmentControllerDepartment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseDepartmentControllerDepartment>>, TError,{id: string;data: NonReadonly<Department>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseDepartmentControllerDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single Department
 */
export const getOneBaseDepartmentControllerDepartment = (
    id: string,
    params?: GetOneBaseDepartmentControllerDepartmentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Department>> => {
    
    return axios.get(
      `/department/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseDepartmentControllerDepartmentQueryKey = (id: string,
    params?: GetOneBaseDepartmentControllerDepartmentParams,) => {
    return [`/department/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseDepartmentControllerDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseDepartmentControllerDepartmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseDepartmentControllerDepartmentQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>> = ({ signal }) => getOneBaseDepartmentControllerDepartment(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseDepartmentControllerDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>>
export type GetOneBaseDepartmentControllerDepartmentQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single Department
 */
export const useGetOneBaseDepartmentControllerDepartment = <TData = Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseDepartmentControllerDepartmentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseDepartmentControllerDepartment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseDepartmentControllerDepartmentQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single Department
 */
export const deleteOneBaseDepartmentControllerDepartment = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/department/${id}`,options
    );
  }



export const getDeleteOneBaseDepartmentControllerDepartmentMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDepartmentControllerDepartment>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDepartmentControllerDepartment>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseDepartmentControllerDepartment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseDepartmentControllerDepartment(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseDepartmentControllerDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseDepartmentControllerDepartment>>>
    
    export type DeleteOneBaseDepartmentControllerDepartmentMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single Department
 */
export const useDeleteOneBaseDepartmentControllerDepartment = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseDepartmentControllerDepartment>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseDepartmentControllerDepartmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const mailControllerSendEmailRemind = (
    sendEmailRemindDto: SendEmailRemindDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/mail/send-email-remind`,
      sendEmailRemindDto,options
    );
  }



export const getMailControllerSendEmailRemindMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerSendEmailRemind>>, TError,{data: SendEmailRemindDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof mailControllerSendEmailRemind>>, TError,{data: SendEmailRemindDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mailControllerSendEmailRemind>>, {data: SendEmailRemindDto}> = (props) => {
          const {data} = props ?? {};

          return  mailControllerSendEmailRemind(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MailControllerSendEmailRemindMutationResult = NonNullable<Awaited<ReturnType<typeof mailControllerSendEmailRemind>>>
    export type MailControllerSendEmailRemindMutationBody = SendEmailRemindDto
    export type MailControllerSendEmailRemindMutationError = AxiosError<unknown>

    export const useMailControllerSendEmailRemind = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerSendEmailRemind>>, TError,{data: SendEmailRemindDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMailControllerSendEmailRemindMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const mailControllerRequestEmailOtp = (
    requestEmailOtpDto: RequestEmailOtpDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/mail/request-email-otp`,
      requestEmailOtpDto,options
    );
  }



export const getMailControllerRequestEmailOtpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerRequestEmailOtp>>, TError,{data: RequestEmailOtpDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof mailControllerRequestEmailOtp>>, TError,{data: RequestEmailOtpDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mailControllerRequestEmailOtp>>, {data: RequestEmailOtpDto}> = (props) => {
          const {data} = props ?? {};

          return  mailControllerRequestEmailOtp(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MailControllerRequestEmailOtpMutationResult = NonNullable<Awaited<ReturnType<typeof mailControllerRequestEmailOtp>>>
    export type MailControllerRequestEmailOtpMutationBody = RequestEmailOtpDto
    export type MailControllerRequestEmailOtpMutationError = AxiosError<unknown>

    export const useMailControllerRequestEmailOtp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerRequestEmailOtp>>, TError,{data: RequestEmailOtpDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMailControllerRequestEmailOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const mailControllerTestMail = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/mail/test-mail`,undefined,options
    );
  }



export const getMailControllerTestMailMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerTestMail>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof mailControllerTestMail>>, TError,void, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mailControllerTestMail>>, void> = () => {
          

          return  mailControllerTestMail(axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type MailControllerTestMailMutationResult = NonNullable<Awaited<ReturnType<typeof mailControllerTestMail>>>
    
    export type MailControllerTestMailMutationError = AxiosError<unknown>

    export const useMailControllerTestMail = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mailControllerTestMail>>, TError,void, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getMailControllerTestMailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const otpControllerGenerateOtp = (
    verifyOtpDto: VerifyOtpDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/otp/generate-otp`,
      verifyOtpDto,options
    );
  }



export const getOtpControllerGenerateOtpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpControllerGenerateOtp>>, TError,{data: VerifyOtpDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof otpControllerGenerateOtp>>, TError,{data: VerifyOtpDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof otpControllerGenerateOtp>>, {data: VerifyOtpDto}> = (props) => {
          const {data} = props ?? {};

          return  otpControllerGenerateOtp(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type OtpControllerGenerateOtpMutationResult = NonNullable<Awaited<ReturnType<typeof otpControllerGenerateOtp>>>
    export type OtpControllerGenerateOtpMutationBody = VerifyOtpDto
    export type OtpControllerGenerateOtpMutationError = AxiosError<unknown>

    export const useOtpControllerGenerateOtp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpControllerGenerateOtp>>, TError,{data: VerifyOtpDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getOtpControllerGenerateOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const otpControllerVerifyOtp = (
    verifyOtpDto: VerifyOtpDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/otp/verify-otp`,
      verifyOtpDto,options
    );
  }



export const getOtpControllerVerifyOtpMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpControllerVerifyOtp>>, TError,{data: VerifyOtpDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof otpControllerVerifyOtp>>, TError,{data: VerifyOtpDto}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof otpControllerVerifyOtp>>, {data: VerifyOtpDto}> = (props) => {
          const {data} = props ?? {};

          return  otpControllerVerifyOtp(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type OtpControllerVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof otpControllerVerifyOtp>>>
    export type OtpControllerVerifyOtpMutationBody = VerifyOtpDto
    export type OtpControllerVerifyOtpMutationError = AxiosError<unknown>

    export const useOtpControllerVerifyOtp = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpControllerVerifyOtp>>, TError,{data: VerifyOtpDto}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getOtpControllerVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single Otp
 */
export const getOneBaseOtpControllerOtp = (
    id: string,
    params?: GetOneBaseOtpControllerOtpParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Otp>> => {
    
    return axios.get(
      `/otp/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseOtpControllerOtpQueryKey = (id: string,
    params?: GetOneBaseOtpControllerOtpParams,) => {
    return [`/otp/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseOtpControllerOtpQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseOtpControllerOtpParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseOtpControllerOtpQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>> = ({ signal }) => getOneBaseOtpControllerOtp(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseOtpControllerOtpQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>>
export type GetOneBaseOtpControllerOtpQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single Otp
 */
export const useGetOneBaseOtpControllerOtp = <TData = Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseOtpControllerOtpParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseOtpControllerOtp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseOtpControllerOtpQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple Otps
 */
export const getManyBaseOtpControllerOtp = (
    params?: GetManyBaseOtpControllerOtpParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyOtpResponseDto>> => {
    
    return axios.get(
      `/otp`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseOtpControllerOtpQueryKey = (params?: GetManyBaseOtpControllerOtpParams,) => {
    return [`/otp`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseOtpControllerOtpQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>, TError = AxiosError<unknown>>(params?: GetManyBaseOtpControllerOtpParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseOtpControllerOtpQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>> = ({ signal }) => getManyBaseOtpControllerOtp(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseOtpControllerOtpQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>>
export type GetManyBaseOtpControllerOtpQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple Otps
 */
export const useGetManyBaseOtpControllerOtp = <TData = Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseOtpControllerOtpParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseOtpControllerOtp>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseOtpControllerOtpQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upload a file
 */
export const clientControllerImportClients = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/client/import-client`,
      formData,options
    );
  }



export const getClientControllerImportClientsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerImportClients>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof clientControllerImportClients>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerImportClients>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  clientControllerImportClients(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ClientControllerImportClientsMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerImportClients>>>
    export type ClientControllerImportClientsMutationBody = FileUploadDTO
    export type ClientControllerImportClientsMutationError = AxiosError<unknown>

    export const useClientControllerImportClients = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerImportClients>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getClientControllerImportClientsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single Client
 */
export const createOneBaseClientControllerClient = (
    client: NonReadonly<Client>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    return axios.post(
      `/client`,
      client,options
    );
  }



export const getCreateOneBaseClientControllerClientMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseClientControllerClient>>, TError,{data: NonReadonly<Client>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseClientControllerClient>>, TError,{data: NonReadonly<Client>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseClientControllerClient>>, {data: NonReadonly<Client>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseClientControllerClient(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseClientControllerClientMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseClientControllerClient>>>
    export type CreateOneBaseClientControllerClientMutationBody = NonReadonly<Client>
    export type CreateOneBaseClientControllerClientMutationError = AxiosError<unknown>

    /**
 * @summary Create a single Client
 */
export const useCreateOneBaseClientControllerClient = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseClientControllerClient>>, TError,{data: NonReadonly<Client>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseClientControllerClientMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple Clients
 */
export const getManyBaseClientControllerClient = (
    params?: GetManyBaseClientControllerClientParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyClientResponseDto>> => {
    
    return axios.get(
      `/client`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseClientControllerClientQueryKey = (params?: GetManyBaseClientControllerClientParams,) => {
    return [`/client`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseClientControllerClientQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClient>>, TError = AxiosError<unknown>>(params?: GetManyBaseClientControllerClientParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClient>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseClientControllerClientQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseClientControllerClient>>> = ({ signal }) => getManyBaseClientControllerClient(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseClientControllerClientQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseClientControllerClient>>>
export type GetManyBaseClientControllerClientQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple Clients
 */
export const useGetManyBaseClientControllerClient = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClient>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseClientControllerClientParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClient>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseClientControllerClientQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single Client
 */
export const updateOneBaseClientControllerClient = (
    id: string,
    client: NonReadonly<Client>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    return axios.patch(
      `/client/${id}`,
      client,options
    );
  }



export const getUpdateOneBaseClientControllerClientMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseClientControllerClient>>, TError,{id: string;data: NonReadonly<Client>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseClientControllerClient>>, TError,{id: string;data: NonReadonly<Client>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseClientControllerClient>>, {id: string;data: NonReadonly<Client>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseClientControllerClient(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseClientControllerClientMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseClientControllerClient>>>
    export type UpdateOneBaseClientControllerClientMutationBody = NonReadonly<Client>
    export type UpdateOneBaseClientControllerClientMutationError = AxiosError<unknown>

    /**
 * @summary Update a single Client
 */
export const useUpdateOneBaseClientControllerClient = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseClientControllerClient>>, TError,{id: string;data: NonReadonly<Client>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseClientControllerClientMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single Client
 */
export const getOneBaseClientControllerClient = (
    id: string,
    params?: GetOneBaseClientControllerClientParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Client>> => {
    
    return axios.get(
      `/client/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseClientControllerClientQueryKey = (id: string,
    params?: GetOneBaseClientControllerClientParams,) => {
    return [`/client/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseClientControllerClientQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClient>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseClientControllerClientParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClient>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseClientControllerClientQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseClientControllerClient>>> = ({ signal }) => getOneBaseClientControllerClient(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClient>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseClientControllerClientQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseClientControllerClient>>>
export type GetOneBaseClientControllerClientQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single Client
 */
export const useGetOneBaseClientControllerClient = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClient>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseClientControllerClientParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClient>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseClientControllerClientQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single Client
 */
export const deleteOneBaseClientControllerClient = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/client/${id}`,options
    );
  }



export const getDeleteOneBaseClientControllerClientMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseClientControllerClient>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseClientControllerClient>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseClientControllerClient>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseClientControllerClient(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseClientControllerClientMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseClientControllerClient>>>
    
    export type DeleteOneBaseClientControllerClientMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single Client
 */
export const useDeleteOneBaseClientControllerClient = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseClientControllerClient>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseClientControllerClientMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const clientControllerClients = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/client/clients`,options
    );
  }


export const getClientControllerClientsQueryKey = () => {
    return [`/client/clients`] as const;
    }

    
export const getClientControllerClientsQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerClients>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerClients>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerClientsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerClients>>> = ({ signal }) => clientControllerClients({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerClients>>, TError, TData> & { queryKey: QueryKey }
}

export type ClientControllerClientsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerClients>>>
export type ClientControllerClientsQueryError = AxiosError<unknown>

export const useClientControllerClients = <TData = Awaited<ReturnType<typeof clientControllerClients>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerClients>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClientControllerClientsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clientControllerEmployees = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/client/employees`,options
    );
  }


export const getClientControllerEmployeesQueryKey = () => {
    return [`/client/employees`] as const;
    }

    
export const getClientControllerEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof clientControllerEmployees>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerEmployees>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientControllerEmployeesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerEmployees>>> = ({ signal }) => clientControllerEmployees({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientControllerEmployees>>, TError, TData> & { queryKey: QueryKey }
}

export type ClientControllerEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerEmployees>>>
export type ClientControllerEmployeesQueryError = AxiosError<unknown>

export const useClientControllerEmployees = <TData = Awaited<ReturnType<typeof clientControllerEmployees>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerEmployees>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClientControllerEmployeesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Import a file
 */
export const employeeControllerImportEmployees = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/employee/import-employee`,
      formData,options
    );
  }



export const getEmployeeControllerImportEmployeesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeeControllerImportEmployees>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof employeeControllerImportEmployees>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeeControllerImportEmployees>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  employeeControllerImportEmployees(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EmployeeControllerImportEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof employeeControllerImportEmployees>>>
    export type EmployeeControllerImportEmployeesMutationBody = FileUploadDTO
    export type EmployeeControllerImportEmployeesMutationError = AxiosError<unknown>

    export const useEmployeeControllerImportEmployees = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeeControllerImportEmployees>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEmployeeControllerImportEmployeesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single Employee
 */
export const createOneBaseEmployeeControllerEmployee = (
    employee: NonReadonly<Employee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Employee>> => {
    
    return axios.post(
      `/employee`,
      employee,options
    );
  }



export const getCreateOneBaseEmployeeControllerEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEmployeeControllerEmployee>>, TError,{data: NonReadonly<Employee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEmployeeControllerEmployee>>, TError,{data: NonReadonly<Employee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseEmployeeControllerEmployee>>, {data: NonReadonly<Employee>}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseEmployeeControllerEmployee(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseEmployeeControllerEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseEmployeeControllerEmployee>>>
    export type CreateOneBaseEmployeeControllerEmployeeMutationBody = NonReadonly<Employee>
    export type CreateOneBaseEmployeeControllerEmployeeMutationError = AxiosError<unknown>

    /**
 * @summary Create a single Employee
 */
export const useCreateOneBaseEmployeeControllerEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseEmployeeControllerEmployee>>, TError,{data: NonReadonly<Employee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseEmployeeControllerEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple Employees
 */
export const getManyBaseEmployeeControllerEmployee = (
    params?: GetManyBaseEmployeeControllerEmployeeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyEmployeeResponseDto>> => {
    
    return axios.get(
      `/employee`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseEmployeeControllerEmployeeQueryKey = (params?: GetManyBaseEmployeeControllerEmployeeParams,) => {
    return [`/employee`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseEmployeeControllerEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>, TError = AxiosError<unknown>>(params?: GetManyBaseEmployeeControllerEmployeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseEmployeeControllerEmployeeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>> = ({ signal }) => getManyBaseEmployeeControllerEmployee(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseEmployeeControllerEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>>
export type GetManyBaseEmployeeControllerEmployeeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple Employees
 */
export const useGetManyBaseEmployeeControllerEmployee = <TData = Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseEmployeeControllerEmployeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseEmployeeControllerEmployee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseEmployeeControllerEmployeeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single Employee
 */
export const updateOneBaseEmployeeControllerEmployee = (
    id: string,
    employee: NonReadonly<Employee>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Employee>> => {
    
    return axios.patch(
      `/employee/${id}`,
      employee,options
    );
  }



export const getUpdateOneBaseEmployeeControllerEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEmployeeControllerEmployee>>, TError,{id: string;data: NonReadonly<Employee>}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEmployeeControllerEmployee>>, TError,{id: string;data: NonReadonly<Employee>}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseEmployeeControllerEmployee>>, {id: string;data: NonReadonly<Employee>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseEmployeeControllerEmployee(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseEmployeeControllerEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseEmployeeControllerEmployee>>>
    export type UpdateOneBaseEmployeeControllerEmployeeMutationBody = NonReadonly<Employee>
    export type UpdateOneBaseEmployeeControllerEmployeeMutationError = AxiosError<unknown>

    /**
 * @summary Update a single Employee
 */
export const useUpdateOneBaseEmployeeControllerEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseEmployeeControllerEmployee>>, TError,{id: string;data: NonReadonly<Employee>}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseEmployeeControllerEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single Employee
 */
export const getOneBaseEmployeeControllerEmployee = (
    id: string,
    params?: GetOneBaseEmployeeControllerEmployeeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Employee>> => {
    
    return axios.get(
      `/employee/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseEmployeeControllerEmployeeQueryKey = (id: string,
    params?: GetOneBaseEmployeeControllerEmployeeParams,) => {
    return [`/employee/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseEmployeeControllerEmployeeQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseEmployeeControllerEmployeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseEmployeeControllerEmployeeQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>> = ({ signal }) => getOneBaseEmployeeControllerEmployee(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseEmployeeControllerEmployeeQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>>
export type GetOneBaseEmployeeControllerEmployeeQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single Employee
 */
export const useGetOneBaseEmployeeControllerEmployee = <TData = Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseEmployeeControllerEmployeeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseEmployeeControllerEmployee>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseEmployeeControllerEmployeeQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single Employee
 */
export const deleteOneBaseEmployeeControllerEmployee = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/employee/${id}`,options
    );
  }



export const getDeleteOneBaseEmployeeControllerEmployeeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEmployeeControllerEmployee>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEmployeeControllerEmployee>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseEmployeeControllerEmployee>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseEmployeeControllerEmployee(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseEmployeeControllerEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseEmployeeControllerEmployee>>>
    
    export type DeleteOneBaseEmployeeControllerEmployeeMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single Employee
 */
export const useDeleteOneBaseEmployeeControllerEmployee = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseEmployeeControllerEmployee>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseEmployeeControllerEmployeeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const eContractScheduleControllerScanSendReminderAfter = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/schedule/scan-send-reminder`,undefined,options
    );
  }



export const getEContractScheduleControllerScanSendReminderAfterMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractScheduleControllerScanSendReminderAfter>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof eContractScheduleControllerScanSendReminderAfter>>, TError,void, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eContractScheduleControllerScanSendReminderAfter>>, void> = () => {
          

          return  eContractScheduleControllerScanSendReminderAfter(axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type EContractScheduleControllerScanSendReminderAfterMutationResult = NonNullable<Awaited<ReturnType<typeof eContractScheduleControllerScanSendReminderAfter>>>
    
    export type EContractScheduleControllerScanSendReminderAfterMutationError = AxiosError<unknown>

    export const useEContractScheduleControllerScanSendReminderAfter = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eContractScheduleControllerScanSendReminderAfter>>, TError,void, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getEContractScheduleControllerScanSendReminderAfterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
